import roadTrip from "../assets/road-trip.jpg";
import HillStation from "../assets/Hill-Station.jpg";
import Adventure from "../assets/Adv.jpeg";
import Img1 from '../assets/Adv.jpeg';
import Img2 from '../assets/Travel.jpeg';
import Img3 from '../assets/hist.jpeg';


import Anant_Img1 from'../assets/Anant_Farm/Image 1-Anant Farm.jpeg';
import Anant_Img2 from'../assets/Anant_Farm/Image 2-Anant Farm.jpeg';
import Anant_Img3 from'../assets/Anant_Farm/Image 3-Anant Farm.jpeg';


import Maharaja1 from "../assets/Maharaja_Family/Image 1-Maharaja Resort.jpeg";
import Maharaja2 from "../assets/Maharaja_Family/Image 2-Maharaja Resort.jpeg";
import Maharaja3 from "../assets/Maharaja_Family/Image 3-Maharaja Resort.jpeg";
import Maharaja4 from "../assets/Maharaja_Family/Image 4-Maharaja Resort.jpeg";


import Swami_Chaya1 from "../assets/swami_chaya/Image 1-Swami.jpeg";
import Swami_Chaya2 from "../assets/swami_chaya/Image 2-Swami.jpeg";
import Swami_Chaya3 from "../assets/swami_chaya/Image 3-Swami.jpeg";
import Orchard1 from "../assets/Orchard_Farm/Image 1-orchard.jpeg";
import Orchard2 from "../assets/Orchard_Farm/Image 2-orchard.jpeg";
import Orchard3 from "../assets/Orchard_Farm/Image 3-Orchard.jpeg";
import Orchard4 from "../assets/Orchard_Farm/Image 4-Orchard.jpeg";
import Atashree1 from "../assets/Atharshree_Farm/Image 1.jpeg";
import Atashree2 from "../assets/Atharshree_Farm/Image 2.jpeg";
import Atashree3 from "../assets/Atharshree_Farm/Image 3.jpeg";
import Atashree4 from "../assets/Atharshree_Farm/Image 4.jpeg";
import Bahar_Home1 from "../assets/Bahar_Home_Stay/Image 1.jpeg";
import Bahar_Home2 from "../assets/Bahar_Home_Stay/Image 2.jpeg";
import Bahar_Home3 from "../assets/Bahar_Home_Stay/Image 3.jpeg";
import Kanishka1 from "../assets/Kanishka_Farmhouse/Image 1.jpeg";
import Kanishka2 from "../assets/Kanishka_Farmhouse/Image 2.jpeg";
import Kanishka3 from "../assets/Kanishka_Farmhouse/Image 3.jpeg";
import Kanishka4 from "../assets/Kanishka_Farmhouse/Image 4.jpeg";
import Parchure1 from "../assets/Parchure_Farm/Image 1.jpeg";
import Parchure2 from "../assets/Parchure_Farm/Image 2.jpeg";
import Parchure3 from "../assets/Parchure_Farm/Image 3.jpeg";
import Parchure4 from "../assets/Parchure_Farm/Image 4.jpeg";
import Parchure5 from "../assets/Parchure_Farm/Image 5.jpeg";
import Parchure6 from "../assets/Parchure_Farm/Image 6.jpeg";
import Mulukh1 from "../assets/Mulukh_Farm/Image 1.jpeg";
import Mulukh2 from "../assets/Mulukh_Farm/Image 2.jpeg";
import Mulukh3 from "../assets/Mulukh_Farm/Image 3.jpeg";
import Mulukh4 from "../assets/Mulukh_Farm/Image 4.jpeg";
import Guest_Paradise1 from "../assets/Guest_Paradise_Villa/Image 1.jpeg";
import Guest_Paradise2 from "../assets/Guest_Paradise_Villa/Image 2.jpeg";
import Guest_Paradise3 from "../assets/Guest_Paradise_Villa/Image 3.jpeg";
import Guest_Paradise4 from "../assets/Guest_Paradise_Villa/Image 4.jpeg";
import Guest_Paradise5 from "../assets/Guest_Paradise_Villa/Image 5.jpeg";
import Rio_Retreat1 from "../assets/Rio_Retreat/Image 1.jpeg";
import Rio_Retreat2 from "../assets/Rio_Retreat/Image 2.jpeg";
import Rio_Retreat3 from "../assets/Rio_Retreat/Image 3.jpeg";
import Rio_Retreat4 from "../assets/Rio_Retreat/Image 4.jpeg";
import NS6_1 from "../assets/NS6/Image 1.jpeg";
import NS6_2 from "../assets/NS6/Image 2.jpeg";
import NS6_3 from "../assets/NS6/Image 3.jpeg";
import NS6_4 from "../assets/NS6/Image 4.jpeg";
import The_Waterfront1 from "../assets/The_waterfront/Image 1.jpeg";
import The_Waterfront2 from "../assets/The_waterfront/Image 2.jpeg";
import The_Waterfront3 from "../assets/The_waterfront/Image 3.jpeg";
import The_Waterfront4 from "../assets/The_waterfront/Image 4.jpeg";
import The_Waterfront5 from "../assets/The_waterfront/Image 5.jpeg";
import The_Waterfront6 from "../assets/The_waterfront/Image 6.jpeg";
import Alibagh_kashid1 from "../assets/Alibagh_Beach_resort_Kashid/Image 1.jpeg";
import Alibagh_kashid2 from "../assets/Alibagh_Beach_resort_Kashid/Image 2.jpeg";
import Alibagh_kashid3 from "../assets/Alibagh_Beach_resort_Kashid/Image 3.jpeg";
import Alibagh_Revdanda1 from "../assets/Alibagh_resort_Revdanda/Image 1.jpeg";
import Alibagh_Revdanda2 from "../assets/Alibagh_resort_Revdanda/Image 2.jpeg";
import Alibagh_Revdanda3 from "../assets/Alibagh_resort_Revdanda/Image 3.jpeg";
import Alibagh_Revdanda4 from "../assets/Alibagh_resort_Revdanda/Image 4.jpeg";
import Kokani_vibes1 from "../assets/Kokani_Vibes/Image 1.jpeg";
import Kokani_vibes2 from "../assets/Kokani_Vibes/Image 2.jpeg";
import Kokani_vibes3 from "../assets/Kokani_Vibes/Image 3.jpeg";
import Kokani_vibes4 from "../assets/Kokani_Vibes/Image 4.jpeg";
import Kokani_vibes5 from "../assets/Kokani_Vibes/Image 5.jpeg";
import Tatva_Sparsh1 from "../assets/Tatva_Sparsh/Image 1.jpeg";
import Tatva_Sparsh2 from "../assets/Tatva_Sparsh/Image 2.jpeg";
import Tatva_Sparsh3 from "../assets/Tatva_Sparsh/Image 3.jpeg";
import Tatva_Sparsh4 from "../assets/Tatva_Sparsh/Image 4.jpeg";

import Nature_Shield1 from "../assets/Nature_shield/nature-shield-1.jpg";
import Nature_Shield2 from "../assets/Nature_shield/nature-shield-2.jpeg";
import Nature_Shield3 from "../assets/Nature_shield/nature-shield-3.jpg";
import Nature_Shield4 from "../assets/Nature_shield/nature-shield-4.jpg";
import Nature_Shield5 from "../assets/Nature_shield/nature-shield-5.jpg";
import Nature_Shield6 from "../assets/Nature_shield/nature-shield-6.jpg";

import Him180_1 from "../assets/Him_180/Image 2.jpeg";
import Him180_2 from "../assets/Him_180/Image 3.jpeg";
import Him180_3 from "../assets/Him_180/Image 4.jpeg";
import Him180_4 from "../assets/Him_180/Image 5.jpeg";
import Him180_5 from "../assets/Him_180/Image 6.jpeg";


import Dale_Home1 from "../assets/Dale_Home_Stay/Image 1.jpeg";
import Dale_Home2 from "../assets/Dale_Home_Stay/Image 2.jpeg";
import Dale_Home3 from "../assets/Dale_Home_Stay/Image 3.jpeg";
import Dale_Home4 from "../assets/Dale_Home_Stay/Image 4.jpeg";

import Western_Ghat1 from "../assets/western_ghat_wild_homestay/Image 1.jpeg";
import Western_Ghat2 from "../assets/western_ghat_wild_homestay/Image 1.jpeg";

import Heaven1 from "../assets/Heaven_Edge/Image 1.jpeg";
import Heaven2 from "../assets/Heaven_Edge/Image 2.jpeg";
import Heaven3 from "../assets/Heaven_Edge/Image 3.jpeg";
import Heaven4 from "../assets/Heaven_Edge/Image 4.jpeg";
import Heaven5 from "../assets/Heaven_Edge/Image 5.jpeg";
import Heaven6 from "../assets/Heaven_Edge/Image 6.jpeg";

import Maachli_Farm1 from "../assets/Maachli_Farm_stay_details/Cottage Exterior.JPG";
import Maachli_Farm2 from "../assets/Maachli_Farm_stay_details/Cottage Interior.JPG";
import Maachli_Farm3 from "../assets/Maachli_Farm_stay_details/Cottage.JPG";
import Maachli_Farm4 from "../assets/Maachli_Farm_stay_details/DSC_3932.JPG";
import Maachli_Farm5 from "../assets/Maachli_Farm_stay_details/Nature View.JPG";
import Maachli_Farm6 from "../assets/Maachli_Farm_stay_details/Restaurant.JPG";

import Olive_Turia1 from "../assets/Olive_Resort_Turia/Image 1-Turia.jpeg"
import Olive_Turia2 from "../assets/Olive_Resort_Turia/Image 2-Turia.jpeg"
import Olive_Turia3 from "../assets/Olive_Resort_Turia/Image 3-Turia.jpeg"
import Olive_Turia4 from "../assets/Olive_Resort_Turia/Image 4-Turia.jpeg"
import Olive_Turia5 from "../assets/Olive_Resort_Turia/Image 5-Turia.jpeg"
import Olive_Turia6 from "../assets/Olive_Resort_Turia/Image 6-Turia.jpeg"

import Banayan_Tree1 from "../assets/Banayan_Tree_camp/Image 1-Banyan.jpeg"
import Banayan_Tree2 from "../assets/Banayan_Tree_camp/Image 2-Banyan.jpeg"
import Banayan_Tree3 from "../assets/Banayan_Tree_camp/Image 3-Banyan.jpeg"
import Banayan_Tree4 from "../assets/Banayan_Tree_camp/Image 4-Banyan.jpeg"

import Welcome_Heritage1 from "../assets/Welcome_Heritage_Resort/Image 1-Heritage.jpeg"
import Welcome_Heritage2 from "../assets/Welcome_Heritage_Resort/Image 2-Heritage.jpeg"
import Welcome_Heritage3 from "../assets/Welcome_Heritage_Resort/Image 3-Heritage.jpeg"
import Welcome_Heritage4 from "../assets/Welcome_Heritage_Resort/Image 5-Heritage.jpeg"

import Tiger_Village1 from "../assets/Tiger_village_resort/Image 1-Tiger village (1).jpeg"
import Tiger_Village2 from "../assets/Tiger_village_resort/Image 1-Tiger village (2).jpeg"
import Tiger_Village3 from "../assets/Tiger_village_resort/Image 1-Tiger village (3).jpeg"
import Tiger_Village4 from "../assets/Tiger_village_resort/Image 1-Tiger village (4).jpeg"
import Tiger_Village5 from "../assets/Tiger_village_resort/Image 1-Tiger village (5).jpeg"

import Dewdrops_Jungle1 from "../assets/Dew_drop_jungle/Image 1.jpeg"
import Dewdrops_Jungle2 from "../assets/Dew_drop_jungle/Image 2.jpeg"
import Dewdrops_Jungle3 from "../assets/Dew_drop_jungle/Image 3.jpeg"
import Dewdrops_Jungle4 from "../assets/Dew_drop_jungle/Image 4.jpeg"
import Dewdrops_Jungle5 from "../assets/Dew_drop_jungle/Image 5.jpeg"
import Dewdrops_Jungle6 from "../assets/Dew_drop_jungle/Image 6.jpeg"

import Pranavam_Resort1 from "../assets/Pranavam_Resort/Image 1.jpg"
import Pranavam_Resort2 from "../assets/Pranavam_Resort/Image 2.jpg"
import Pranavam_Resort3 from "../assets/Pranavam_Resort/Image 3.jpg"
import Pranavam_Resort4 from "../assets/Pranavam_Resort/Image 4.jpg"
import Pranavam_Resort5 from "../assets/Pranavam_Resort/Image 5.jpg"

import shalgahr_Villa1 from "../assets/Shalgahr_Villa/Image 1.jpeg"
import shalgahr_Villa2 from "../assets/Shalgahr_Villa/Image 2.jpeg"
import shalgahr_Villa3 from "../assets/Shalgahr_Villa/Image 3.jpeg"
import shalgahr_Villa4 from "../assets/Shalgahr_Villa/Image 4.jpeg"

import Bottom_Palm1 from "../assets/Bottom_plam_resort/image 1.jpeg"
import Bottom_Palm2 from "../assets/Bottom_plam_resort/image 2.jpeg"
import Bottom_Palm3 from "../assets/Bottom_plam_resort/image 3.jpeg"
import Bottom_Palm4 from "../assets/Bottom_plam_resort/image 4.jpeg"

import Whispering1 from "../assets/Whispering_woods/WhatsApp Image 2022-07-13 at 11.42.23 AM.jpeg";
import Whispering2 from "../assets/Whispering_woods/WhatsApp Image 2022-07-13 at 11.42.24 AM (1).jpeg";
import Whispering3 from "../assets/Whispering_woods/WhatsApp Image 2022-07-13 at 11.42.24 AM.jpeg";

import Agreen_Resort1 from "../assets/Agreen_resort/Image 1-Agreen.jpg"
import Agreen_Resort2 from "../assets/Agreen_resort/Image 2-Agreen.jpg"
import Agreen_Resort3 from "../assets/Agreen_resort/Image 3-Agreen.jpg"
import Agreen_Resort4 from "../assets/Agreen_resort/Image 4-Agreen.jpg"
import Agreen_Resort5 from "../assets/Agreen_resort/Image 5-Agreen.jpg"
import Agreen_Resort6 from "../assets/Agreen_resort/Image 6-Agreen.jpg"
 
import Gondwana1 from "../assets/Gondwana_Premium_Jungle_homes/Image 2.jpeg"
import Gondwana2 from "../assets/Gondwana_Premium_Jungle_homes/Image 7.jpeg"
import Gondwana3 from "../assets/Gondwana_Premium_Jungle_homes/Image 3.jpeg"
import Gondwana4 from "../assets/Gondwana_Premium_Jungle_homes/Image 4.jpeg"
import Gondwana5 from "../assets/Gondwana_Premium_Jungle_homes/Image 5.jpeg"
import Gondwana6 from "../assets/Gondwana_Premium_Jungle_homes/Image 6.jpeg"

import Mangaal1 from "../assets/Mangaal_Farmstay/image 1.jpeg"
import Mangaal2 from "../assets/Mangaal_Farmstay/image 2.jpeg"
import Mangaal3 from "../assets/Mangaal_Farmstay/image 3.jpeg"
import Mangaal4 from "../assets/Mangaal_Farmstay/image 4.jpeg"
import Mangaal5 from "../assets/Mangaal_Farmstay/image 5.jpeg"

import Gunjan1 from "../assets/Gunjan_Farm_Stay/Image 1-Gunjan Farm.jpeg"
import Gunjan2 from "../assets/Gunjan_Farm_Stay/Image 2-Gunjan Farm.jpeg"
import Gunjan3 from "../assets/Gunjan_Farm_Stay/Image 3-Gunjan Farm.jpeg"
import Gunjan4 from "../assets/Gunjan_Farm_Stay/Image 4-Gunjan Farm.jpeg"

import Pawna_Lake1 from "../assets/Pawna_Nature_Camping/Image 1-Pawna.jpeg"
import Pawna_Lake2 from "../assets/Pawna_Nature_Camping/Image 2-Pawna.jpeg"
import Pawna_Lake3 from "../assets/Pawna_Nature_Camping/Image 3-Pawna.jpeg"
import Pawna_Lake4 from "../assets/Pawna_Nature_Camping/Image 4-Pawna.jpeg"
import Pawna_Lake5 from "../assets/Pawna_Nature_Camping/Image 5-Pawna.jpeg"

import Seaview1 from "../assets/Searview_camping/Image 1.jpeg"
import Seaview2 from "../assets/Searview_camping/Image 2.jpeg"
import Seaview3 from "../assets/Searview_camping/Image 3.jpeg"
import Seaview4 from "../assets/Searview_camping/Image 4.jpeg"

import Green_Valley1 from "../assets/Green_Valley_Amboli/Image 1.jpeg"
import Green_Valley2 from "../assets/Green_Valley_Amboli/Image 2.jpeg"
import Green_Valley3 from "../assets/Green_Valley_Amboli/Image 3.jpeg"
import Green_Valley4 from "../assets/Green_Valley_Amboli/Image 4.jpeg"

import Andra_Lake1 from "../assets/Andra_Lake/Image 1.jpeg"
import Andra_Lake2 from "../assets/Andra_Lake/Image 2.jpeg"
import Andra_Lake3 from "../assets/Andra_Lake/Image 3.jpeg"

import Blue_Lagoon1 from "../assets/Blue_Lagoon_Resort/Image 1-Blue Lagoon.jpeg"
import Blue_Lagoon2 from "../assets/Blue_Lagoon_Resort/Image 2-Blue Lagoon.jpeg"
import Blue_Lagoon3 from "../assets/Blue_Lagoon_Resort/Image 3-Blue Lagoon.jpeg"
import Blue_Lagoon4 from "../assets/Blue_Lagoon_Resort/Image 4-Blue Lagoon.jpeg"
import Blue_Lagoon5 from "../assets/Blue_Lagoon_Resort/Image 5-Blue Lagoon.jpeg"
import Blue_Lagoon6 from "../assets/Blue_Lagoon_Resort/Image 6-Blue Lagoon.jpeg"


import Nityanand1 from "../assets/Nityanand_Pride_Resort/Image 1 Nityanand pride.jpeg"
import Nityanand2 from "../assets/Nityanand_Pride_Resort/Image 2 Nityanand pride.jpeg"
import Nityanand3 from "../assets/Nityanand_Pride_Resort/Image 3 Nityanand pride.jpeg"
import Nityanand4 from "../assets/Nityanand_Pride_Resort/Image 4 Nityanand pride.jpeg"

import Kshitij_Holiday1 from "../assets/Kshitij_Holiday/Image 1-Diveagar.jpeg"
import Kshitij_Holiday2 from "../assets/Kshitij_Holiday/Image 2-Diveagar.jpeg"
import Kshitij_Holiday3 from "../assets/Kshitij_Holiday/Image 3-Diveagar.jpeg"

import Tranquil1 from "../assets/Tranquil_Home_Stay_kelshi/Image 1.jpeg"
import Tranquil2 from "../assets/Tranquil_Home_Stay_kelshi/Image 2.jpeg"
import Tranquil3 from "../assets/Tranquil_Home_Stay_kelshi/Image 3.jpeg"
import Tranquil4 from "../assets/Tranquil_Home_Stay_kelshi/Image 4.jpeg"
import Tranquil5 from "../assets/Tranquil_Home_Stay_kelshi/Image 5.jpeg"
import Tranquil6 from "../assets/Tranquil_Home_Stay_kelshi/Image 6.jpeg"


import Arunday1 from "../assets/Arunoday_kihim/Image 1.jpeg"
import Arunday2 from "../assets/Arunoday_kihim/Image 2.jpeg"
import Arunday3 from "../assets/Arunoday_kihim/Image 3.jpeg"
import Arunday4 from "../assets/Arunoday_kihim/Image 4.jpeg"

import Sagari1 from "../assets/Sagari_kinara_resort/Image 1.jpeg"
import Sagari2 from "../assets/Sagari_kinara_resort/Image 2.jpeg"
import Sagari3 from "../assets/Sagari_kinara_resort/Image 3.jpeg"

import Hrishivan1 from "../assets/Hrishivan_Villas_Nagaon/Image 1.jpeg"
import Hrishivan2 from "../assets/Hrishivan_Villas_Nagaon/Image 2.jpeg"
import Hrishivan3 from "../assets/Hrishivan_Villas_Nagaon/Image 3.jpeg"
import Hrishivan4 from "../assets/Hrishivan_Villas_Nagaon/Image 4.jpeg"
import Hrishivan5 from "../assets/Hrishivan_Villas_Nagaon/Image 5.jpeg"
import Hrishivan6 from "../assets/Hrishivan_Villas_Nagaon/Image 6.jpeg"

import Saiesh1 from "../assets/Saiesh_Resort/Image 1.jpeg"
import Saiesh2 from "../assets/Saiesh_Resort/Image 2.jpeg"
import Saiesh3 from "../assets/Saiesh_Resort/Image 3.jpeg"

import Kirti1 from "../assets/Kirti_Cottage/Image 1.jpeg"
import Kirti2 from "../assets/Kirti_Cottage/Image 2.jpeg"
import Kirti3 from "../assets/Kirti_Cottage/Image 3.jpeg"
import Kirti4 from "../assets/Kirti_Cottage/Image 4.jpeg"

import Klub_khavana1 from "../assets/Klub_Khanavane/Image 1.jpeg"
import Klub_khavana2 from "../assets/Klub_Khanavane/Image 2.jpeg"
import Klub_khavana3 from "../assets/Klub_Khanavane/Image 3.jpeg"
import Klub_khavana4 from "../assets/Klub_Khanavane/Image 4.jpeg"

import Aqua_bliss1 from "../assets/Aqua bliss/Image 1.jpeg"
import Aqua_bliss2 from "../assets/Aqua bliss/Image 2.jpeg"
import Aqua_bliss3 from "../assets/Aqua bliss/Image 4.jpeg"

import Casa_Da_Chaul1 from "../assets/Casa_Da_Chaul/image 1.jpeg"
import Casa_Da_Chaul2 from "../assets/Casa_Da_Chaul/iamge 2.jpeg"
import Casa_Da_Chaul3 from "../assets/Casa_Da_Chaul/image 3.jpeg"
import Casa_Da_Chaul4 from "../assets/Casa_Da_Chaul/iamge 4.jpeg"

import chaitanya1 from "../assets/Chaitanya_Home_stay/Image 1.jpeg"
import chaitanya2 from "../assets/Chaitanya_Home_stay/Image 2.jpeg"
import chaitanya3 from "../assets/Chaitanya_Home_stay/Image 3.jpeg"


import sanctuary1 from "../assets/Santuary Tadoba resort/Image 1-Santuary.jpeg"
import sanctuary2 from "../assets/Santuary Tadoba resort/Image 2-Santuary.jpeg"
import sanctuary3 from "../assets/Santuary Tadoba resort/Image 3-Santuary.jpeg"
import sanctuary4 from "../assets/Santuary Tadoba resort/Image 4-Santuary.jpeg"


import olivesillari1 from "../assets/Olive resort Sillari/Image 1-Sillari.jpeg"
import olivesillari2 from "../assets/Olive resort Sillari/Image 2-Sillari.jpeg"
import olivesillari3 from "../assets/Olive resort Sillari/Image 3-Sillari.jpeg"
import olivesillari4 from "../assets/Olive resort Sillari/Image 4-Sillari.jpeg"
import olivesillari5 from "../assets/Olive resort Sillari/Image 5-Sillari.jpeg"


import mango1 from "../assets/all_resort_photo/mango1.jpg"
import mango2 from "../assets/all_resort_photo/mango2.jpg"
import mango3 from "../assets/all_resort_photo/mango3.jpg"


import pool6BHK1 from "../assets/all_resort_photo/pool1.jpg"
import pool6BHK2 from "../assets/all_resort_photo/pool2.jpg"
import pool6BHK3 from "../assets/all_resort_photo/mango1.jpg"
import pool6BHK4 from "../assets/all_resort_photo/pool4.jpg"
import pool6BHK5 from "../assets/all_resort_photo/pool5.jpg"
import pool6BHK6 from "../assets/all_resort_photo/pool6.jpg"

import villagecamp1 from "../assets/all_resort_photo/village_camp1.jpg"
import villagecamp2 from "../assets/all_resort_photo/village_camp2.jpg"
import villagecamp3 from "../assets/all_resort_photo/village_camp3.jpg"
import villagecamp4 from "../assets/all_resort_photo/village_camp4.jpg"

export const farmsData = [
    {
      name: "Anant Farms A Homely Resort",
      price: "₹3000.00",
      host: "Anirudha Ambekar",
      address: "Brahmanghar, near Velhe (421212)",
      city: "Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      discoverlink:"/seemore",
      images: [Anant_Img1, Anant_Img2, Anant_Img3],
  },
  {
      name: "6 BHK Villa With Private Pool",
      price: "₹38300.00",
      host: "Bhavin Kapadia",
      address: "Opposite Lohana Sanitorium,Lonavala(410401)",
      city: "Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [pool6BHK1, pool6BHK2, pool6BHK3, pool6BHK4, pool6BHK5, pool6BHK6],
    },
  {
      name: "Maharaja Family Guest House",
      price: "₹1560.00",
      host: "Sameer Ingle",
      address: "Plot 33. Pradhan Park,Lonavala(410401)",
      city: "Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Maharaja1, Maharaja2, Maharaja3, Maharaja4],
    },
  {
      name: "Swami Chyya Resort",
      price: "₹1650.00",
      host: "Vinayak Gawade",
      address: "Nagav,Beach Road,Alibag(402209)",
      city: "Rajgad",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Swami_Chaya1, Swami_Chaya2, Swami_Chaya3],
    },
  {
      name: "Orchard Farm House",
      price: "₹2100.00",
      host: "Manish Katti",
      address: "Kolhapur-Hupari Road(416001)",
      city: "	Kolhapur",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Orchard1, Orchard2, Orchard3, Orchard4],
    },
  {
      name: "PARCHURE FARM",
      price: "₹2100.00",
      host: "Prashant Parchure",
      address: "Plot No-24, aanandvan society, hambarpada, dahiwali,Neral(410101)",
      city: "	Raigad",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Parchure1, Parchure2, Parchure3, Parchure4,Parchure5, Parchure6],
    },
  {
      name: "Kanishka Farmstay",
      price: "₹1650.00",
      host: "Umesh Matale",
      address: "Ghodshet ShirkoliTaluka VelhaDist pune(412212)",
      city: "	Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Kanishka1, Kanishka2, Kanishka3,Kanishka4],
    },
  {
      name: "Bahar Home Stay",
      price: "₹1650.00",
      host: "Manisha Oak",
      address: "Brahmanwadi, Gimhavane, near Gajanan Maharaj Mandir, Gimhavane, Dapoli, Maharashtra(415712)",
      city: "	Konkan",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Bahar_Home1, Bahar_Home2, Bahar_Home3],
    },
  {
      name: "Mango forest resort",
      price: "₹2300.00",
      host: "Ranjeet Dhumal",
      address: "Proposed MH 65 Highway Towards Madhe Waterfall Village Kolambi Taluka Velhe(412212)",
      city: "	Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [mango1, mango2, mango3],
    },
  {
      name: "Athashree Farm",
      price: "₹3800.00",
      host: "Shivaji Akhade",
      address: "Polekar wadi donje Gera sinhgad Pune(411025)",
      city: "	Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Atashree1, Atashree2, Atashree3, Atashree4],
    },
  {
      name: "Mulukh Farm Agri",
      price: "₹1760.00",
      host: "Balasaheb Pilane",
      address: "A/p Dahitane Dahitane deokarwadi road Tal- Daund(412207)",
      city: "	Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Mulukh1, Mulukh2, Mulukh3, Mulukh4],
    },
  {
      name: "Guest paradise villa",
      price: "₹23000.00",
      host: "Mubarak Urunkar",
      address: "Ankit group society plot no 48 near Malvali railway station Lonavala(410301)",
      city: "	Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Guest_Paradise1, Guest_Paradise2, Guest_Paradise3, Guest_Paradise4, Guest_Paradise5],
    },
  {
      name: "Rio Retreat",
      price: "₹2750.00",
      host: "Zinnet Abbasaly",
      address: "Kashele on khandas road next to Penn frozen karjat(414402)",
      city: "	Kalyan",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Rio_Retreat1, Rio_Retreat2, Rio_Retreat3, Rio_Retreat4],
    },
  {
      name: "NS6",
      price: "₹9350.00",
      host: "shital",
      address: "B-2 Platinum Phase MARs Co op Hsg Society Lavale(412115)",
      city: "	Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [NS6_1, NS6_2, NS6_3, NS6_4],
    },
  {
      name: "The Waterfront Kolad",
      price: "₹2310.00",
      host: "RK Bajpai",
      address: "Sutarwadi Reservoir Dhagadwadi Kolad Durtoli Kolad Maharashtra(402308)",
      city: "	Raigad",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [The_Waterfront1, The_Waterfront2, The_Waterfront3, The_Waterfront4, The_Waterfront5, The_Waterfront6],
    },
  {
      name: "Alibagh Beach Resort-Kashid",
      price: "₹1400.00",
      host: "SWARUP KONDE",
      address: "KASHID BEACH,Alibagh(402201)",
      city: "	Raigad",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Alibagh_kashid1, Alibagh_kashid2, Alibagh_kashid3],
    },
  {
      name: "Alibagh Beach-Revdanda",
      price: "₹1670.00",
      host: "SWARUP KONDE",
      address: "REVDANDA BEACH,Alibagh(402201)",
      city: "	Raigad",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Alibagh_Revdanda1, Alibagh_Revdanda2, Alibagh_Revdanda3,Alibagh_Revdanda4],
    },
  {
      name: "Kokani Vibes-Alibag",
      price: "₹1400.00",
      host: "Susmit Tirlotkar",
      address: "At Post sasawane (kana), tel- alibag, dist -raigad(402201)",
      city: "	Raigad",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Kokani_vibes1, Kokani_vibes2, Kokani_vibes3, Kokani_vibes4, Kokani_vibes5],
    },
  {
      name: "Tatva Sparsh",
      price: "₹1400.00",
      host: "Jatin Chadha",
      address: "Survey no. 50, Village Givshi, Shirkoli Road Panshet Dam Backwaters, Taluka, Velhe(412107)",
      city: "	Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Tatva_Sparsh1, Tatva_Sparsh2, Tatva_Sparsh3, Tatva_Sparsh4],
    }
  ];

  export const hillStationData = [
    {
      name: "Nature Shield",
      price: "₹3200.00",
      host: "Nature Shield",
      address: "Near Datta Mandir, Bhaja Village, Malavli, Lonavla(410405)",
      city: "Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      discoverlink:"/seemore",
      images: [Nature_Shield1, Nature_Shield2, Nature_Shield3, Nature_Shield4, Nature_Shield5, Nature_Shield6],
  },
  {
      name: "Him180",
      price: "₹2300.00",
      host: "Neeraj Singh Nayal",
      address: "	Sauni, Ranikhet, Almora Uttarakhand(263663)",
      city: "Dehra Dun",
      state: "Uttaranchal",
      country: "India",
      discovermore:"Discover More",
      images: [Him180_1, Him180_2, Him180_3, Him180_4, Him180_5],
    },
  {
      name: "Dale Site Home stay",
      price: "₹2100.00",
      host: "Ankush Thakur",
      address: "	Kharwa chowki Shoghi,Shimla(HP),NH5(171001)",
      city: "Shimla",
      state: "Himachal Pradesh",
      country: "India",
      discovermore:"Discover More",
      images: [Dale_Home1, Dale_Home2, Dale_Home3, Dale_Home4],
    },
  {
      name: "Western Ghat Wild Home Stays",
      price: "₹1650.00",
      host: "Hemant Waman Phadtare",
      address: "Parut Po Taldev Tal Mahabaleshwar Dist Satara Maharashtra(412806)",
      city: "Satara",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Western_Ghat1, Western_Ghat2],
    },
  {
      name: "Heavens Edge Agro Tourism",
      price: "₹2200.00",
      host: "Swapnali Karande",
      address: "	Tapola road , Mahabaleshwar(412806)",
      city: "	Satara",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Heaven1, Heaven2, Heaven3, Heaven4, Heaven5, Heaven6],
    },

  ];

 export const nightLifeData = [
    {
      name: "Mangaal Farmstay",
      price: "₹7700.00",
      host: "Sweta",
      address: "Mangaal Village Netravi Quepem Taluka South Goa(403704)",
      city: "	Quepem",
      state: "Goa",
      country: "India",
      discovermore:"Discover More",
      discoverlink:"/seemore",
      images: [Mangaal1, Mangaal2, Mangaal3, Mangaal4, Mangaal5],
  },
  {
      name: "Bhandardara Lakeside Camping",
      price: "₹1200.00",
      host: "Harish Pote",
      address: "Near Shivshakti Hotel,At Murshet, Post Shendi, Tal Akole(422601)",
      city: "Ahmadnagar",
      state: "	Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Gondwana1, Gondwana2, Gondwana3, Gondwana4, Gondwana5, Gondwana6],
    },
  {
      name: "Gunjan Farm House",
      price: "₹1400.00",
      host: "Gunjan Chheda",
      address: "	Shirkoli near panshet dam(412107)",
      city: "Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Gunjan1, Gunjan2, Gunjan3, Gunjan4],
    },
  {
      name: "Pawna Lake Nature Camping",
      price: "₹1650.00",
      host: "Narendra Tamboli",
      address: "	Pawna Nature Camping(410406)",
      city: "Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Pawna_Lake1, Pawna_Lake2, Pawna_Lake3, Pawna_Lake4, Pawna_Lake5],
    },
  {
      name: "Seaview Camping",
      price: "₹2300.00",
      host: "Akshay Dungu",
      address: "	Near Aniruddha Resort,Barshiv, Revdanda-Murud Road(402401)",
      city: "	Raigad",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Seaview1, Seaview2, Seaview3, Seaview4],
    },
  {
      name: "Green valley camping",
      price: "1400.00",
      host: "Ishan Joshi",
      address: "Trambak Amboli dam velunje road Amboli(416510)",
      city: "	Konkan",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Green_Valley1, Green_Valley2, Green_Valley3, Green_Valley4],
    },
  {
      name: "Andra lake camping and farm house",
      price: "1320.00",
      host: "Jitu pavale",
      address: "	Address Ghat No 124 Takawe Bhoire Road Near Kondiwade Bridge Falane P O Takwae Maharashtra(412106)",
      city: "	Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Andra_Lake1, Andra_Lake2, Andra_Lake3],
    },

  ];


   export const adventureData = [
    {
      name: "Forest Villas-Agreen Villa",
      price: "₹23000.00",
      host: "Puja Kale",
      address: "Mangaal Village Netravi Quepem Taluka South Goa(403704)",
      city: "	Satara",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      discoverlink:"/seemore",
      images: [Agreen_Resort1, Agreen_Resort2, Agreen_Resort3, Agreen_Resort4, Agreen_Resort5, Agreen_Resort6],
  },
  {
      name: "Maachli, Home Stay",
      price: "₹9300.00",
      host: "Prathamesh Samant",
      address: "	Ishavasyam,Major State highway 4(Coastal highway),Manjardewadi, At Post-Parule,Tal-Vengurle, Dist-Sindhudurg(416523)",
      city: "Sindhudurg",
      state: "	Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Maachli_Farm1, Maachli_Farm2, Maachli_Farm3, Maachli_Farm4, Maachli_Farm5,Maachli_Farm6],
    },
  {
      name: "Village camp",
      price: "₹4100.00",
      host: "Nazeem khan",
      address: "	Pench National Park,Sillari(480661)",
      city: "	Nagpur",
      state: "	Madhya Pradesh",
      country: "India",
      discovermore:"Discover More",
      images: [villagecamp1, villagecamp2, villagecamp3, villagecamp4],
    },
  {
      name: "Olive Resort-Sillari",
      price: "₹3800.00",
      host: "Neha Uikey",
      address: "	Pench National Park,Sillari(480661)",
      city: "	Nagpur",
      state: "	Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [olivesillari1, olivesillari2, olivesillari3, olivesillari4, olivesillari5],
    },
  {
      name: "Olive Resort-Turia",
      price: "₹3800.00",
      host: "Neha Uikey",
      address: "Pench Natioanl Park,Turia(480661)",
      city: "Seoni",
      state: "	Madhya Pradesh",
      country: "India",
      discovermore:"Discover More",
      images: [Olive_Turia1, Olive_Turia2, Olive_Turia3, Olive_Turia4, Olive_Turia5, Olive_Turia6],
    },
  {
      name: "The Sanctuary -Tadoba Resort",
      price: "₹4800.00",
      host: "Nitin Mahajan",
      address: "Pench Natioanl Park,Turia(480661)",
      city: "Seoni",
      state: "	Maharashtra",
      country: "India",
      discovermore:"Discover More",
     images: [sanctuary1, sanctuary2, sanctuary3, sanctuary4],
    },
  {
      name: "BANYAN TREE CAMP",
      price: "₹5700.00",
      host: "Suman Manna",
      address: "Pench National Park,Pench(480661)",
      city: "	Shivapuri",
      state: "Madhya Pradesh",
      country: "India",
      discovermore:"Discover More",
      images: [Banayan_Tree1, Banayan_Tree2, Banayan_Tree3, Banayan_Tree4],
    },
  {
      name: "Welcome heritage Resort",
      price: "₹6600.00",
      host: "Pankaj Kukde",
      address: "Pench National Park,Turia Gate(480661)",
      city: "		Seoni",
      state: "	Madhya Pradesh",
      country: "India",
      discovermore:"Discover More",
      images: [Welcome_Heritage1, Welcome_Heritage2, Welcome_Heritage3, Welcome_Heritage4],
    },
  {
      name: "Tiger Village Resort",
      price: "₹6060.00",
      host: "Jitu pavale",
      address: "Moharli Gate, Tadoba, Moharli(442404)",
      city: "	Chandrapur",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Tiger_Village1, Tiger_Village2, Tiger_Village3, Tiger_Village4, Tiger_Village5],
    },
  {
      name: "DEWDROPS JUNGLE RESORT",
      price: "₹3800.00",
      host: "Sahana Kamat",
      address: "Kogilban, Dandeli(581325)",
      city: "	DANDELI",
      state: "Karnataka",
      country: "India",
      discovermore:"Discover More",
      images: [Dewdrops_Jungle1, Dewdrops_Jungle2, Dewdrops_Jungle3, Dewdrops_Jungle4, Dewdrops_Jungle5, Dewdrops_Jungle6],
    },
  {
      name: "Pranavam Resort",
      price: "₹7700.00",
      host: "Homayon Khoram",
      address: "Pranavam Resort Pozhuthana Vythiri Wayanad(673575)",
      city: "	Wayanad",
      state: "Kerala",
      country: "India",
      discovermore:"Discover More",
      images: [Pranavam_Resort1, Pranavam_Resort2, Pranavam_Resort3, Pranavam_Resort4, Pranavam_Resort5],
    },
  {
      name: "Shalgar Villa the homestay",
      price: "₹2100.00",
      host: "sovhita shalgar",
      address: "4 kms close to kaas valley of flowers kaas plateau Satara Maharashtra(415013)",
      city: "	Satara",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [shalgahr_Villa1, shalgahr_Villa2, shalgahr_Villa3, shalgahr_Villa4],
    },
  {
      name: "Bottom Palm Resort",
      price: "₹2750.00",
      host: "Nikhil Dushing",
      address: "	Near madhe ghat waterfall, village Shenwad, Velhe Pune taluka Maharashtra(412212)",
      city: "	Pune",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Bottom_Palm1, Bottom_Palm2, Bottom_Palm3, Bottom_Palm4],
    },
  {
      name: "Whispering Jungle Homestay",
      price: "₹2200.00",
      host: "Aziz Bhori",
      address: "Amba Ghat Kolhapur(415101)",
      city: "	Kolhapur",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Whispering1, Whispering2, Whispering3],
    },
  {
      name: "Gondwana Premium Jungle Home Saty",
      price: "₹6600.00",
      host: "Anjali Joshi",
      address: "Gondwana Premium Jungle Resort Madanapur Chimur Maharashtra(442903)",
      city: "	Chandrapur",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Gondwana1, Gondwana2, Gondwana3, Gondwana4, Gondwana5, Gondwana6],
    },
  {
      name: "SS",
      price: "₹1260.00",
      host: "swa",
      address: "hiii(411043)",
      city: "	Karjat",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [villagecamp1, villagecamp2, villagecamp3, villagecamp4],
    },

  ];

 export const beachesData = [
    {
      name: "Blue Lagoon Khavane Resort",
      price: "₹4100.00",
      host: "Avinash Khot",
      address: "Khavane Beach,Konkan(416207)",
      city: "	Konkan",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      discoverlink:"/seemore",
      images: [Blue_Lagoon1, Blue_Lagoon2, Blue_Lagoon3, Blue_Lagoon4, Blue_Lagoon5, Blue_Lagoon6],
  },
  {
      name: "Nityanand Pride Beach Resort",
      price: "₹ 3200.00",
      host: "Manish katti",
      address: "Tondavali(Madhali),karanjewadi StopMalvan(416606)",
      city: "Sindhudurg",
      state: "	Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Nityanand1, Nityanand2, Nityanand3, Nityanand4],
    },
  {
      name: "Bangli Home-Stay",
      price: "₹4100.00",
      host: "Ameya Bal",
      address: "Ameya Nursery,Village Ladghar,Tal:Dapoli,Dist: Ratnagiri(415712)",
      city: "	Ratnagiri",
      state: "	Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [The_Waterfront1, The_Waterfront2, The_Waterfront3, The_Waterfront4, The_Waterfront5, The_Waterfront6],
    },
  {
      name: "Kshitij Holiday Resort",
      price: "₹ 3900.00",
      host: "Makarand Chitale",
      address: "	Suvarna Ganesh Pakhadi, Shrivardhan Rd, Diveagar(402404)",
      city: "Konkan",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Kshitij_Holiday1, Kshitij_Holiday2, Kshitij_Holiday3],
    },
  {
      name: "Tranquil Home Stay",
      price: "₹ 2300.00",
      host: "Yogesh Bhagwat",
      address: "Pranjape Lane Kelshi, Tal- Dapoli Dist- RatnagiriI(415717)",
      city: "	Ratnagiri",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Tranquil1, Tranquil2, Tranquil3, Tranquil4, Tranquil5, Tranquil6],
    },
  {
      name: "ARUNODAY KIHIM",
      price: "₹2100.00",
      host: "Anuprita Patil",
      address: "At PostKihim,Bhandar Ali,kalbhairav Lane,Alibagh(402201)",
      city: "	Raigad",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Arunday1, Arunday2, Arunday3, Arunday4],
    },
  {
      name: "Sagari Kinara",
      price: "₹2300.00",
      host: "Swapnil Mathre",
      address: "Sasawane Beach Road Home Sasawane(402201)",
      city: "	Raigad",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Sagari1, Sagari2, Sagari3],
    },
  {
      name: "Hrishivan Villas Nagaon",
      price: "₹3000.00",
      host: "Bhumit Gala",
      address: "3006, valanj paroda, nagaon, alibag(402201)",
      city: "	Raigad",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Hrishivan1, Hrishivan2, Hrishivan3, Hrishivan4, Hrishivan5, Hrishivan6],
    },
  {
      name: "Saiesh Resort",
      price: "₹2000.00",
      host: "Niwas Sakhalkar",
      address: "Sasawane, Near Pednekar Maharaj Aashram., Alibag(402201)",
      city: "	Raigad",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Saiesh1, Saiesh2, Saiesh3],
    },
  {
      name: "Kirti cottage",
      price: "₹2000.00",
      host: "Kaustubh Bhingarde",
      address: "Bhingarde Hotel Kirti At & Post - Dhokwade No.1, Tal. - Alibag, Dist. - Raigad(402201)",
      city: "	Raigad",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Kirti1, Kirti2, Kirti3, Kirti4],
    },
  {
      name: "Klub Khavana Beachfront Resort",
      price: "₹2300.00",
      host: "Samir Sataradekar",
      address: "Khavane beach Maruti Mandir Rd Mhapan Vengurla Maharashtra(416522)",
      city: "	Konkan",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Klub_khavana1, Klub_khavana2, Klub_khavana3, Klub_khavana4],
    },
  {
      name: "Aqua Bliss - A Comfort Family Stay",
      price: "₹3800.00",
      host: "Amey Pusalkar",
      address: "103 Varchi pakhadi Dapoli Murud near durgadevi mandir.(415713)",
      city: "	Ratnagiri",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Aqua_bliss1 , Aqua_bliss2, Aqua_bliss3],
    },
  {
      name: "Casa Da Chaul",
      price: "₹23000.00",
      host: "Alhad Bhide",
      address: "ChaulNear Alibag(402203)",
      city: "	Raigad",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [Casa_Da_Chaul1, Casa_Da_Chaul2, Casa_Da_Chaul3, Casa_Da_Chaul4],
    },
  {
      name: "Ishan laukik niwas",
      price: "₹4200.00",
      host: "Ishan laukik",
      address: "Dapoli - Harnai road, near Palande beach, Harnai, MH SH4, Dapoli, Maharashtra 415713(415713)",
      city: "	Ratnagiri",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [villagecamp1, villagecamp2, villagecamp3, villagecamp4],
    },

     {
      name: "Chaitanya Home Stay",
      price: "₹ 1320.00",
      host: "swapnaja sawant",
      address: "House no. 93 madhala watar sadamirya ratnagiri(412516)",
      city: "	Ratnagiri",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
      images: [chaitanya1, chaitanya2, chaitanya3],
    },

     {
      name: "Ratnavihar Residency",
      price: "₹1100.00",
      host: "Mandar Kadam",
      address: "House No 516 At Post Basani Taluka Ratnagiri(415612)",
      city: "	Ratnagiri",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
       images: [Pranavam_Resort1, Pranavam_Resort2, Pranavam_Resort3, Pranavam_Resort4, Pranavam_Resort5],
    },

      {
      name: "Ri Cottage",
      price: "₹1540.00",
      host: "Sunit Suresh Shildankar",
      address: "Govt. Hospital, Near, Dhokawade, At- Sasawane, (Ramnagar), Tal- Alibag - Dist - Raigad .Mandwa Road, Alibag, Maharashtra(402201)",
      city: "	Raigad",
      state: "Maharashtra",
      country: "India",
      discovermore:"Discover More",
            images: [Swami_Chaya1, Swami_Chaya2, Swami_Chaya3],
    },

  ];



export const formsDataDetails = [ 
  //RoadTrip
  //1st

    {
      Information:"Host Details",
      host: "Anirudha Ambekar",
      email: "anirudha.ambekar@gmail.com",
      phone: "+91-9970765500",
      address: "Brahmanghar, near Velhe (421212)",
      city:"Pune",
      state:"Maharashtra",
      country:"India",
      images: [Anant_Img1, Anant_Img2, Anant_Img3],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Anant Farms A Homely Resort",
      description: "Beautiful space",
      bedrooms: "2",
      singleBeds: "4",
      doubleBeds: "4",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "8",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "6",
      maxGuestsAllowed: "20",
      basicFacilities: "Air Conditioning, Tea & Coffee Maker, Essentials, First Aid Kit, Fire Extinguisher",
      entertainmentFacilities: "Flat-screen TV, Sauna",
      cookingCleaningFacilities: "Kitchen, Kitchenette",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "3000.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

//2nd
    {
      Information:"Host Details",
      host: "Bhavin Kapadia",
      email: "bhavinkapadia44@gmail.com",
      phone: "+91-9970765500",
      address: "Opposite Lohana Sanitorium,Lonavala(410401) Pune, Maharashtra, India",
      city:"Pune",
      state:"Maharashtra",
      country:"India",
      images: [pool6BHK1, pool6BHK2, pool6BHK3, pool6BHK4, pool6BHK5, pool6BHK6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "6 BHK Villa With Private Pool",
      
      
      description: "Beautiful space",
      bedrooms: "6",
      singleBeds: "6",
      doubleBeds: "6",
      livingRooms: "1",
      otherSpaces: "1",
      adultsAllowed: "6",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "6",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Tea & Coffee Maker, Essentials, First Aid Kit, Fire Extinguisher",
      entertainmentFacilities: "Flat-screen TV, Sauna",
      cookingCleaningFacilities: "Kitchen, Kitchenette",
      breakfastAvailable: "Yes",
      checkInTime: "14:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "38300.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",

        
    },
//3rd
    {
      Information:"Host Details",
      host: "Sameer Ingle",
      email: "info@holidaymax.in",
      phone: "+91-9970765500",
      address: "Plot 33. Pradhan Park,Lonavala(410401) Pune, Maharashtra, India",
      city:"Pune",
      state:"Maharashtra",
      country:"India",
      images: [Maharaja1, Maharaja2, Maharaja3, Maharaja4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Maharaja Family Guest House",
      description: "Beautiful space",
      bedrooms: "10",
      singleBeds: "6",
      doubleBeds: "10",
      livingRooms: "1",
      otherSpaces: "6",
      adultsAllowed: "30",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "7",
      maxGuestsAllowed: "8",
      basicFacilities: "air conditioning,Free wifi,Heating,Tea & Coffe Maker,Desk/workspace,Essentials",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen,Washing machine",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "1560.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",

        
    },
//4th
    {
      Information:"Host Details",
      host: "Vinayak Gawade",
      email: "vinayakgawade27@gmail.com",
      phone: "+91-9970765500",
      address: "Nagav,Beach Road,Alibag(402209)",
      state:"Maharashtra",
      country:"India",
      images: [Swami_Chaya1, Swami_Chaya2, Swami_Chaya3],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Swami Chyya Resort",
      
      
      description: "Beautiful space",
      bedrooms: "6",
      singleBeds: "4",
      doubleBeds: "6",
      livingRooms: "0",
      otherSpaces: "0",
      adultsAllowed: "14",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "6",
      maxGuestsAllowed: "14",
      basicFacilities: "Air Conditioning, Tea & Coffee Maker, Essentials, First Aid Kit, Fire Extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "1650.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",

        
    },
//5th
    {
      Information:"Host Details",
      host: "Manish Katti",
      email: "kastooritravels.kop@gmail.com",
      phone: "+91-9970765500",
      address: "Kolhapur-Hupari Road(416001) Kolhapur, Maharashtra, India",
      state:"Maharashtra",
      country:"India",
      images: [Orchard1, Orchard2, Orchard3, Orchard4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "Orchard Farm House",
      
      
      description: "Beautiful space",
      bedrooms: "15",
      singleBeds: "15",
      doubleBeds: "15",
      livingRooms: "5",
      otherSpaces: "4",
      adultsAllowed: "25",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "8",
      maxGuestsAllowed: "20",
      basicFacilities: "Air Conditioning, Tea & Coffee Maker, Essentials, First Aid Kit, Fire Extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool,Minibar,Sauna,",
      cookingCleaningFacilities: "Kitchen,Washing machine,Laundry",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "10:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "2100.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",

        
    },
//6th
    {
      Information:"Host Details",
      host: "Prashant Parchure",
      email: "parchure39@gmail.com",
      phone: "+91-9970765500",
      address: "Plot No-24, aanandvan society, hambarpada, dahiwali,Neral(410101)",
      state:"Maharashtra",
      country:"India",
       images: [Parchure1, Parchure2, Parchure3, Parchure4,Parchure5, Parchure6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "PARCHURE FARM",
      
      
      description: "Featuring a garden, an outdoor pool and river views, Parchure Farm is located in Neral.",
      bedrooms: "5",
      singleBeds: "3",
      doubleBeds: "5",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "15",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "10",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Tea & Coffee Maker, Essentials, First Aid Kit, Fire Extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "9:00:00",
      checkOutTime: "9:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed",
      totalPriceINR: "2100.00",
      singleOccupation: "1100",
      doubleOccupation: "2200",
      extraBedWithPerson: "330",
      adultBreakfast: "165",
      adultLunch: "275",
      adultDinner: "385",
      childBreakfast: "83",
      childLunch: "99",
      childDinner: "121",

        
    },
//7th
    {
      Information:"Host Details",
      host: "Umesh Matale",
      email: "umeshmatale9@gmail.com",
      phone: "+91-9970765500",
      address: "Ghodshet ShirkoliTaluka VelhaDist pune(412212)",
      state:"Maharashtra",
      country:"India",
      images: [Kanishka1, Kanishka2, Kanishka3,Kanishka4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "Kanishka Farmstay",
      
      
      description: "Escape to the heart of evergreen Kanishka farm for short break every year. A gorgeous agriculture-farm with an eco-friendly purpose, Kanishka Farm makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "6",
      singleBeds: "4",
      doubleBeds: "6",
      livingRooms: "1",
      otherSpaces: "5",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "10",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Tea & Coffee Maker, Essentials, First Aid Kit, Fire Extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "1650.00",
      singleOccupation: "1650",
      doubleOccupation: "1650",
      extraBedWithPerson: "220",
      adultBreakfast: "165",
      adultLunch: "385",
      adultDinner: "495",
      childBreakfast: "83",
      childLunch: "121",
      childDinner: "132",

        
    },
//8th
    {
      Information:"Host Details",
      host: "Manisha Oak",
      email: "baharhomestay@gmail.com",
      phone: "+91-9970765500",
      address: "Brahmanwadi, Gimhavane, near Gajanan Maharaj Mandir, Gimhavane, Dapoli, Maharashtra(415712)",
      state:"Maharashtra",
      country:"India",
      images: [Bahar_Home1, Bahar_Home2, Bahar_Home3],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "Bahar Home Stay",
      
      
      description: "	Escape to the heart of evergreen Bahar Home Stay for short break every year. A gorgeous resort with an eco-friendly purpose, Bahar Home Stay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "6",
      singleBeds: "6",
      doubleBeds: "6",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "Air conditioning,Free wifi,Essentials,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "10:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "1650.00",
      singleOccupation: "1650",
      doubleOccupation: "1650",
      extraBedWithPerson: "330",
      adultBreakfast: "105",
      adultLunch: "385",
      adultDinner: "385",
      childBreakfast: "28",
      childLunch: "105",
      childDinner: "105",

        
    },
//9th
    {
      Information:"Host Details",
      host: "Ranjeet Dhumal",
      email: "info@mangoforestagrotourisum.com",
      phone: "+91-9970765500",
      address: "Proposed MH 65 Highway Towards Madhe Waterfall Village Kolambi Taluka Velhe(412212)",
      state:"Maharashtra",
      country:"India",
       images: [mango1, mango2, mango3],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "Mango forest resort",    
      description: "	Escape to the heart of evergreen Mango forest Resort for short break every year. A gorgeous resort with an eco-friendly purpose, Mango forest Resort makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "6",
      singleBeds: "6",
      doubleBeds: "6",
      livingRooms: "1",
      otherSpaces: "3",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "Air conditioning,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "10:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "2300.00",
      singleOccupation: "2200",
      doubleOccupation: "2200",
      extraBedWithPerson: "330",
      adultBreakfast: "83",
      adultLunch: "935",
      adultDinner: "935",
      childBreakfast: "50",
      childLunch: "138",
      childDinner: "138",

        
    },
//10th
    {
      Information:"Host Details",
      host: "Shivaji Akhade",
      email: "athashreefarm11@gmail.com",
      phone: "+91-9970765500",
      address: "Polekar wadi donje Gera sinhgad Pune(411025)",
      state:"Maharashtra",
      country:"India",
      images: [roadTrip, HillStation, Adventure, roadTrip, HillStation, Adventure],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "Athashree Farm",
      
      
      description: "Escape to the heart of evergreen Kanishka farm for short break every year. A gorgeous agriculture-farm with an eco-friendly purpose, Kanishka Farm makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "8",
      singleBeds: "8",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Free wifi,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher,",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "13:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "3800.00",
      singleOccupation: "3850",
      doubleOccupation: "3850",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",

        
    },
//11th
    {
      Information:"Host Details",
      host: "Balasaheb Pilane",
      email: "mulukhfarminfo@gmail.com",
      phone: "+91-9970765500",
      address: "A/p Dahitane Dahitane deokarwadi road Tal- Daund(412207) Pune, Maharashtra, India",
      state:"Maharashtra",
      country:"India",
      images: [Mulukh1, Mulukh2, Mulukh3, Mulukh4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "Mulukh Farm Agri",
      
      
      description: "Escape to the heart of evergreen Kanishka farm for short break every year. A gorgeous agriculture-farm with an eco-friendly purpose, Kanishka Farm makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "8",
      singleBeds: "8",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "15",
      basicFacilities: "Free wifi,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "13:00:00",
      checkOutTime: "11:00:00",
      rules: "	Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "1760.00",
      singleOccupation: "3850",
      doubleOccupation: "1760",
      extraBedWithPerson: "1980",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",

        
    },
//12th
    {
      Information:"Host Details",
      host: "Mubarak Urunkar",
      email: "paradisevilla2022@gmail.com",
      phone: "+91-9970765500",
      address: "Ankit group society plot no 48 near Malvali railway station Lonavala(410301) Pune, Maharashtra, India",
      state:"Maharashtra",
      country:"India",
      images: [Guest_Paradise1, Guest_Paradise2, Guest_Paradise3, Guest_Paradise4, Guest_Paradise5],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "Guest paradise villa",
      
      
      description: "Escape to the heart of evergreen Kanishka farm for short break every year. A gorgeous agriculture-farm with an eco-friendly purpose, Kanishka Farm makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "4",
      singleBeds: "4",
      doubleBeds: "4",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "5",
      basicFacilities: "Air Conditioning, Free wifi,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher,",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "13:00:00",
      checkOutTime: "11:00:00",
      rules: "Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "23000.00",
      singleOccupation: "22000",
      doubleOccupation: "22000",
      extraBedWithPerson: "1000",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",

        
    },
//13th
    // {
    //   Information:"Host Details",
    //   host: "Shivaji Akhade",
    //   email: "athashreefarm11@gmail.com",
    //   phone: "+91-9970765500",
    //   address: "Polekar wadi donje Gera sinhgad Pune(411025)",
    //   state:"Maharashtra",
    //   country:"India",
    //   images: [Rio_Retreat1, Rio_Retreat2, Rio_Retreat3, Rio_Retreat4],
    //   mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
    //   name: "Rio Retreat",
      
      
    //   description: "Escape to the heart of evergreen Kanishka farm for short break every year. A gorgeous agriculture-farm with an eco-friendly purpose, Kanishka Farm makes for a unique travel experience for those who want to escape the hectic city life.",
    //   bedrooms: "8",
    //   singleBeds: "8",
    //   doubleBeds: "8",
    //   livingRooms: "1",
    //   otherSpaces: "2",
    //   adultsAllowed: "10",
    //   childrenAllowed: "YES",
    //   childAgeLimit: "1",
    //   numberOfChildrenAllowed: "5",
    //   maxGuestsAllowed: "10",
    //   basicFacilities: "Air Conditioning, Free wifi,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher,",
    //   entertainmentFacilities: "Flat-screen TV,Swimming Pool",
    //   cookingCleaningFacilities: "Kitchen",
    //   breakfastAvailable: "Yes",
    //   checkInTime: "13:00:00",
    //   checkOutTime: "11:00:00",
    //   rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
    //   totalPriceINR: "3800.00",
    //   singleOccupation: "3850",
    //   doubleOccupation: "3850",
    //   extraBedWithPerson: "0",
    //   adultBreakfast: "0",
    //   adultLunch: "0",
    //   adultDinner: "0",
    //   childBreakfast: "0",
    //   childLunch: "0",
    //   childDinner: "0",

        
    // },
//14th
    {
      Information:"Host Details",
      host: "Zinnet Abbasaly",
      email: "rioretreat0786@gmail.com",
      phone: "+91-9970765500",
      address: "Kashele on khandas road next to Penn frozen karjat(414402) Kalyan, Maharashtra, India",
      state:"Maharashtra",
      country:"India",
      images: [roadTrip, HillStation, Adventure, roadTrip, HillStation, Adventure],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "Rio Retreat",
      
      
      description: "Escape to the heart of evergreen Kanishka farm for short break every year. A gorgeous agriculture-farm with an eco-friendly purpose, Kanishka Farm makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "10",
      singleBeds: "10",
      doubleBeds: "10",
      livingRooms: "1",
      otherSpaces: "3",
      adultsAllowed: "15",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "10",
      maxGuestsAllowed: "15",
      basicFacilities: "air conditioning,Free wifi,Heating,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "11:00:00",
      rules: "	Children Allowed,Parties/Events Allowed",
      totalPriceINR: "2750.00",
      singleOccupation: "2750",
      doubleOccupation: "5500",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",

        
    },
//15th
    {
      Information:"Host Details",
      host: "shital",
      email: "sakole1@gmail.com",
      phone: "+91-9970765500",
      address: "B-2 Platinum Phase MARs Co op Hsg Society Lavale(412115)",
      state:"Maharashtra",
      country:"India",
      images: [NS6_1, NS6_2, NS6_3, NS6_4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "NS6",
           
      description: "Escape to the heart of evergreen Kanishka farm for short break every year. A gorgeous agriculture-farm with an eco-friendly purpose, Kanishka Farm makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "8",
      singleBeds: "8",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "8",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "4",
      maxGuestsAllowed: "8",
      basicFacilities: "air conditioning,Free wifi,Heating,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV",
      cookingCleaningFacilities: "Kitchen,Washing machine,Laundry",
      breakfastAvailable: "Yes",
      checkInTime: "14:00:00",
      checkOutTime: "12:00:00",
      rules: "Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "9350.00",
      singleOccupation: "9350.00",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",

        
    },
//16th
    {
      Information:"Host Details",
      host: "RK Bajpai",
      email: "bajpairl@gmail.com",
      phone: "+91-9970765500",
      address: "Sutarwadi Reservoir Dhagadwadi Kolad Durtoli Kolad Maharashtra(402308) Raigad, Maharashtra, India",
      state:"Maharashtra",
      country:"India",
       images: [The_Waterfront1, The_Waterfront2, The_Waterfront3, The_Waterfront4, The_Waterfront5, The_Waterfront6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "The Waterfront Kolad",
      
      
      description: "Escape to the heart of evergreen Kanishka farm for short break every year. A gorgeous agriculture-farm with an eco-friendly purpose, Kanishka Farm makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "8",
      singleBeds: "8",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "3",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "4",
      maxGuestsAllowed: "4",
      basicFacilities: "air conditioning,Free wifi,Heating,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "14:00:00",
      checkOutTime: "11:00:00",
      rules: "Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: " 2310.00",
      singleOccupation: "1925",
      doubleOccupation: "3850",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "350",
      adultDinner: "450",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",

        
    },
//17th
    {
      Information:"Host Details",
      host: "Shivaji Akhade",
      email: "athashreefarm11@gmail.com",
      phone: "+91-9970765500",
      address: "Polekar wadi donje Gera sinhgad Pune(411025)",
      state:"Maharashtra",
      country:"India",
     images: [Alibagh_kashid1, Alibagh_kashid2, Alibagh_kashid3],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "Alibagh Beach Resort-Kashid",
      
      description: "Escape to the heart of evergreen Kanishka farm for short break every year. A gorgeous agriculture-farm with an eco-friendly purpose, Kanishka Farm makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "NA",
      tent:"10",
      singleBeds: "NA",
      bathroom:"Private Room",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "Camp Fire Facility,Restaurant and cafe,Adventure Activities",
      entertainmentFacilities: "NA",
      cookingCleaningFacilities: "NA",
      breakfastAvailable: "Yes",
      checkInTime: "13:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "1400.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "NA",
      adultBreakfast: "NA",
      adultLunch: "NA",
      adultDinner: "NA",
      childBreakfast: "NA",
      childLunch: "NA",
      childDinner: "NA",

        
    },
//18th
    {
      Information:"Host Details",
      host: "SWARUP KONDE",
      email: "swarupkonde38@gmail.com",
      phone: "+91-9970765500",
      address: "REVDANDA BEACH,Alibagh(402201)",
      state:"Maharashtra",
      country:"India",
     images: [Alibagh_Revdanda1, Alibagh_Revdanda2, Alibagh_Revdanda3,Alibagh_Revdanda4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "Alibagh Beach-Revdanda",
      
      description: "NA",
      bedrooms: "NA",
      tent:"10",
      singleBeds: "NA",
      doubleBeds: "NA",
      livingRooms: "NA",
      otherSpaces: "NA",
      adultsAllowed: "NA",
      childrenAllowed: "NA",
      childAgeLimit: "NA",
      numberOfChildrenAllowed: "NA",
      maxGuestsAllowed: "NA",
      basicFacilities: "Camp Fire Facility,Restaurant and cafe,Adventure Activities",
      entertainmentFacilities: "NA",
      cookingCleaningFacilities: "NA",
      breakfastAvailable: "Yes",
      checkInTime: "15:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "1670.00",
      singleOccupation: "NA",
      doubleOccupation: "NA",
      extraBedWithPerson: "NA",
      adultBreakfast: "NA",
      adultLunch: "NA",
      adultDinner: "NA",
      childBreakfast: "NA",
      childLunch: "NA",
      childDinner: "NA",

        
    },
//19th
    {
      Information:"Host Details",
      host: "Susmit Tirlotkar",
      email: "susmittirlotkar@gmail.com",
      phone: "+91-8169492252",
      address: "At Post sasawane (kana), tel- alibag, dist -raigad(402201) Raigad, Maharashtra, India",
      state:"Maharashtra",
      country:"India",
     images: [Kokani_vibes1, Kokani_vibes2, Kokani_vibes3, Kokani_vibes4, Kokani_vibes5],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "Kokani Vibes-Alibag",
      
      
      description: "Escape to the heart of evergreen Kanishka farm for short break every year. A gorgeous agriculture-farm with an eco-friendly purpose, Kanishka Farm makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "NA",
      tent:"8",
      singleBeds: "NA",
      doubleBeds: "NA",
      livingRooms: "NA",
      otherSpaces: "NA",
      adultsAllowed: "NA",
      childrenAllowed: "NA",
      childAgeLimit: "NA",
      numberOfChildrenAllowed: "NA",
      maxGuestsAllowed: "NA",
      basicFacilities: "	Camp Fire Facility,Adventure Activities",
      entertainmentFacilities: "NA",
      cookingCleaningFacilities: "NA",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "1400.00",
      singleOccupation: "3850",
      doubleOccupation: "3850",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",

        
    },
//20th
    {
      Information:"Host Details",
      host: "Jatin Chadha",
      email: "tatvasparsh@gmail.com",
      phone: "+91 9202202202",
      address: "Survey no. 50, Village Givshi, Shirkoli Road Panshet Dam Backwaters, Taluka, Velhe(412107) Pune, Maharashtra, India",
      state:"Maharashtra",
      country:"India",
     images: [Tatva_Sparsh1, Tatva_Sparsh2, Tatva_Sparsh3, Tatva_Sparsh4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So PRVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty.",
      name: "Tatva Sparsh",
      
      
      description: "Escape to the heart of evergreen Kanishka farm for short break every year. A gorgeous agriculture-farm with an eco-friendly purpose, Kanishka Farm makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "NA",
      tent:"8",
      singleBeds: "NA",
      doubleBeds: "NA",
      livingRooms: "NA",
      otherSpaces: "NA",
      adultsAllowed: "NA",
      childrenAllowed: "NA",
      childAgeLimit: "NA",
      numberOfChildrenAllowed: "NA",
      maxGuestsAllowed: "NA",
      basicFacilities: "Camp Fire Facility,Restaurant and cafe,Adventure Activities,",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "15:00:00",
      checkOutTime: "11:00:00",
      rules: "Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "1400.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",

        
    },


    // Hillstation data
//1st
    {
      Information:"Host Details",
      host: "Ashish Konde",
      email: "natureshieldhotel@gmail.com",
      phone: "+91-9970765500",
      address: "Near Datta Mandir, Bhaja Village, Malavli, Lonavla(410405) Pune, Maharashtra, India",
      city:"Pune",
      state:"Maharashtra",
      country:"India",
      images: [Nature_Shield1, Nature_Shield2, Nature_Shield3, Nature_Shield4, Nature_Shield5, Nature_Shield6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Nature Shield",
      description: "Beautiful space",
      bedrooms: "10",
      singleBeds: "5",
      doubleBeds: "10",
      livingRooms: "1",
      otherSpaces: "5",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "10",
      maxGuestsAllowed: "10",
      basicFacilities: "Air conditioning,Free wifi,Heating,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "10:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "3200.00",
      singleOccupation: "2750",
      doubleOccupation: "3300",
      extraBedWithPerson: "330",
      adultBreakfast: "165",
      adultLunch: "385",
      adultDinner: "495",
      childBreakfast: "83",
      childLunch: "121",
      childDinner: "121",
  
    },
    //2nd
    {
      Information:"Host Details",
      host: "Neeraj Singh Nayal",
      email: "him180glamp@gmail.com",
      phone: "+91-9970765500",
      address: "Sauni, Ranikhet, Almora Uttarakhand(263663) Dehra Dun, Uttaranchal, India",
      state:"Maharashtra",
      country:"India",
      images: [Him180_1, Him180_2, Him180_3, Him180_4, Him180_5],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Him180",
      description: "Beautiful space",
      bedrooms: "8",
      singleBeds: "5",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "4",
      adultsAllowed: "15",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "10",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Free wifi,Heating,Free on-site parking,Iron,Hairdryer,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen,Laundry",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "10:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "2300.00",
      singleOccupation: "1650",
      doubleOccupation: "2200",
      extraBedWithPerson: "330",
      adultBreakfast: "220",
      adultLunch: "495",
      adultDinner: "605",
      childBreakfast: "110",
      childLunch: "121",
      childDinner: "132",
  
    },
    //3rd
    {
      Information:"Host Details",
      host: "Ankush Thakur",
      email: "ankush.thakur.t@gmail.com",
      phone: "+91-9970765500",
      address: "Kharwa chowki Shoghi,Shimla(HP),NH5(171001) Shimla, Himachal Pradesh, India",
      state:"Maharashtra",
      country:"India",
     images: [Dale_Home1, Dale_Home2, Dale_Home3, Dale_Home4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Dale Site Home stay",
      description: "Beautiful space",
      bedrooms: "4",
      singleBeds: "4",
      doubleBeds: "4",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "6",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Tea & Coffee Maker, Essentials, First Aid Kit, Fire Extinguisher",
      entertainmentFacilities: "Flat-screen TV",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "13:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed, Pets Allowed, Children Allowed, Parties/Events Allowed",
      totalPriceINR: "2100.00",
      singleOccupation: "825",
      doubleOccupation: "825",
      extraBedWithPerson: "330",
      adultBreakfast: "83",
      adultLunch: "495",
      adultDinner: "495",
      childBreakfast: "50",
      childLunch: "121",
      childDinner: "121",
  
    },
    //4th
    {
      Information:"Host Details",
      host: "Hemant Waman Phadtare",
      email: "wgwhomestays@gmail.com",
      phone: "+91-9970765500",
      address: "Parut Po Taldev Tal Mahabaleshwar Dist Satara Maharashtra(412806) Satara, Maharashtra, India",
      state:"Maharashtra",
      country:"India",
      images: [Western_Ghat1, Western_Ghat2],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Western Ghat Wild Home Stays",
      description: "Beautiful space",
      bedrooms: "8",
      singleBeds: "8",
      doubleBeds: "10",
      livingRooms: "1",
      otherSpaces: "4",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "6",
      maxGuestsAllowed: "20",
      basicFacilities: "Air Conditioning,Heating,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "09:30:00",
      checkOutTime: "09:30:00",
      rules: "Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "1650.00",
      singleOccupation: "1649",
      doubleOccupation: "1649",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },
    //5th
    {
      Information:"Host Details",
      host: "Swapnali Karande",
      email: "swapnali0257@gmail.com",
      phone: "+91-9970765500",
      address: "Tapola road , Mahabaleshwar(412806) Satara, Maharashtra, India",
      state:"Maharashtra",
      country:"India",
      images: [Heaven1, Heaven2, Heaven3, Heaven4, Heaven5, Heaven6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Heavens Edge Agro Tourism",
      description: "Beautiful space",
      bedrooms: "8",
      singleBeds: "8",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "3",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Tea & Coffee Maker, Essentials, First Aid Kit, Fire Extinguisher",
      entertainmentFacilities: "Flat-screen TV",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "12:00:00",
      rules: "Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "2200.00",
      singleOccupation: "2200",
      doubleOccupation: "2200",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

//Night life
  //1th
    {
      Information:"Host Details",
      host: "Sweta",
      email: "swapnali0257@gmail.com",
      phone: "+91-9970765500",
      address: "Mangaal Village Netravi Quepem Taluka South Goa(403704)",
      state:"	Goa",
      country:"	India",
      images: [Mangaal1, Mangaal2, Adventure, Mangaal4, Mangaal5],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Mangaal Farmstay",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "8",
      singleBeds: "8",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "3",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Tea & Coffee Maker, Essentials, First Aid Kit, Fire Extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "11:00:00",
      rules: "Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "7700.00",
      singleOccupation: "7700",
      doubleOccupation: "8800",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },
  //2th
    {
      Information:"Host Details",
      host: "Harish Pote",
      email: "swapnali0257@gmail.com",
      phone: "+91-9970765500",
      address: "Near Shivshakti Hotel,At Murshet, Post Shendi, Tal Akole(422601)",
      state:"	Maharashtra",
      country:"	India",
      images: [Gondwana1, Gondwana2, Gondwana3, Gondwana4, Gondwana5, Gondwana6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Bhandardara Lakeside Camping",
      description: "Beautiful space",
       bedrooms: "NA",
      tent:"10",
      singleBeds: "NA",
      doubleBeds: "NA",
      livingRooms: "NA",
      otherSpaces: "NA",
      adultsAllowed: "NA",
      childrenAllowed: "NA",
      childAgeLimit: "NA",
      numberOfChildrenAllowed: "NA",
      maxGuestsAllowed: "NA",
      basicFacilities: "Camp Fire Facility,Restaurant and cafe,Adventure Activities",
      entertainmentFacilities: "NA",
      cookingCleaningFacilities: "NA",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "12:00:00",
      rules: "Smoking Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "1200.00",
      singleOccupation: "2200",
      doubleOccupation: "2200",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },
  //3th
    {
      Information:"Host Details",
      host: "Gunjan Chheda",
      email: "gunjanfarm@gmail.com",
      phone: "+91 08805008434",
      address: "Shirkoli near panshet dam(412107) Pune, Maharashtra, India",
      state:"	Maharashtra",
      country:"	India",
      images: [Gunjan1, Gunjan2, Gunjan3, Gunjan4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Gunjan Farm House",
      description: "Beautiful space",
       bedrooms: "NA",
      tent:"10",
      doubleBeds: "NA",
      livingRooms: "NA",
      otherSpaces: "NA",
      adultsAllowed: "NA",
      childrenAllowed: "NA",
      childAgeLimit: "NA",
      numberOfChildrenAllowed: "NA",
      maxGuestsAllowed: "NA",
      basicFacilities: "Camp Fire Facility,Restaurant and cafe,Adventure Activities,",
      entertainmentFacilities: "NA",
      tentTypes: "Non AC Tents,Air Cooler Tents,AC Tents,",
      cookingCleaningFacilities: "NA",
      breakfastAvailable: "Yes",
      checkInTime: "15:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "1400.00",
      singleOccupation: "NA",
      doubleOccupation: "NA",
      extraBedWithPerson: "NA",
      adultBreakfast: "NA",
      adultLunch: "NA",
      adultDinner: "NA",
      childBreakfast: "NA",
      childLunch: "NA",
      childDinner: "NA",
  
    },
  //4th
    {
      Information:"Host Details",
      host: "Narendra Tamboli",
      email: "booking@pawnanaturecamp.com",
      phone: "+91-8007451234",
      address: "Pawna Nature Camping(410406) Pune, Maharashtra, India",
      state:"	Maharashtra",
      country:"	India",
      images: [Pawna_Lake1, Pawna_Lake2, Pawna_Lake3, Pawna_Lake4, Pawna_Lake5],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Pawna Lake Nature Camping",
      description: "Beautiful space",
     bedrooms: "NA",
      tent:"10",
      singleBeds: "NA",
      doubleBeds: "NA",
      livingRooms: "NA",
      otherSpaces: "NA",
      adultsAllowed: "NA",
      childrenAllowed: "NA",
      childAgeLimit: "NA",
      numberOfChildrenAllowed: "NA",
      maxGuestsAllowed: "NA",
      basicFacilities: "Camp Fire Facility,Restaurant and cafe,Adventure Activities,",
      entertainmentFacilities: "NA",
      tentTypes:"Non AC Tents,Air Cooler Tents,Premium Camping Tents",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "16:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "1650.00",
      singleOccupation: "2200",
      doubleOccupation: "2200",
      extraBedWithPerson: "NA",
      adultBreakfast: "NA",
      adultLunch: "NA",
      adultDinner: "NA",
      childBreakfast: "NA",
      childLunch: "NA",
      childDinner: "NA",
  
    },
  //5th
    {
      Information:"Host Details",
      host: "Akshay Dungu",
      email: "akshaydungu2405@gmail.com",
      phone: "+91-9029020210",
      address: "Near Aniruddha Resort,Barshiv, Revdanda-Murud Road(402401) Raigad, Maharashtra, India",
      state:"	Maharatshtra",
      country:"	India",
      images: [Seaview1, Seaview2, Seaview3, Seaview4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Seaview Camping",
      description: "Beautiful space",
      bedrooms: "NA",
      tent:"10",
      singleBeds: "NA",
      doubleBeds: "NA",
      livingRooms: "NA",
      otherSpaces: "NA",
      adultsAllowed: "NA",
      childrenAllowed: "YES",
      childAgeLimit: "NA",
      numberOfChildrenAllowed: "NA",
      maxGuestsAllowed: "NA",
      basicFacilities: "Camp Fire Facility,Restaurant and cafe,Adventure Activities",
      entertainmentFacilities: "NA",
      tentTypes:"Non AC Tents,Air Cooler Tents,Premium Camping Tents",
      cookingCleaningFacilities: "NA",
      breakfastAvailable: "Yes",
      checkInTime: "16:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "2300.00",
      singleOccupation: "NA",
      doubleOccupation: "NA",
      extraBedWithPerson: "NA",
      adultBreakfast: "NA",
      adultLunch: "NA",
      adultDinner: "NA",
      childBreakfast: "NA",
      childLunch: "NA",
      childDinner: "NA",
  
    },

    //6th
    {
      Information:"Host Details",
      host: "Ishan Joshi",
      email: "ishjo88@gmail.com",
      phone: "+91-9822284446",
      address: "Trambak Amboli dam velunje road Amboli(416510) Konkan, Maharashtra, India",
      state:"	Maharatshtra",
      country:"	India",
     images: [Green_Valley1, Green_Valley2, Green_Valley3, Green_Valley4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Green valley camping",
      description: "Beautiful space",
      bedrooms: "NA",
      tent:"8",
      singleBeds: "NA",
      doubleBeds: "NA",
      livingRooms: "NA",
      otherSpaces: "NA",
      adultsAllowed: "NA",
      childrenAllowed: "YES",
      childAgeLimit: "NA",
      numberOfChildrenAllowed: "NA",
      maxGuestsAllowed: "NA",
      basicFacilities: "	Camp Fire Facility,Restaurant and cafe,Adventure Activities",
      entertainmentFacilities: "NA",
      tentTypes:"Non AC Tents,Air Cooler Tents,Premium Camping Tents",
      cookingCleaningFacilities: "NA",
      breakfastAvailable: "Yes",
      checkInTime: "17:00:00",
      checkOutTime: "10:00:00",
      rules: "Children Allowed,Parties/Events Allowed",
      totalPriceINR: "1400.00",
      singleOccupation: "NA",
      doubleOccupation: "NA",
      extraBedWithPerson: "NA",
      adultBreakfast: "NA",
      adultLunch: "NA",
      adultDinner: "NA",
      childBreakfast: "NA",
      childLunch: "NA",
      childDinner: "NA",
  
    },
    
    //7th
    {
      Information:"Host Details",
      host: "Jitu pavale",
      email: "ishjo88@gmail.com",
      phone: "+91-9834852529",
      address: "Address Ghat No 124 Takawe Bhoire Road Near Kondiwade Bridge Falane P O Takwae Maharashtra(412106) Pune, Maharashtra, India",
      state:"	Maharatshtra",
      country:"	India",
     images: [Andra_Lake1, Andra_Lake2, Andra_Lake3],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Andra lake camping and farm house",
      description: "Beautiful space",
      bedrooms: "NA",
      tent:"8",
      singleBeds: "NA",
      doubleBeds: "NA",
      livingRooms: "NA",
      otherSpaces: "NA",
      adultsAllowed: "NA",
      childrenAllowed: "YES",
      childAgeLimit: "NA",
      numberOfChildrenAllowed: "NA",
      maxGuestsAllowed: "NA",
      basicFacilities: "	Camp Fire Facility,Restaurant and cafe,Adventure Activities",
      entertainmentFacilities: "NA",
      tentTypes:"Non AC Tents,Air Cooler Tents,Premium Camping Tents",
      cookingCleaningFacilities: "NA",
      breakfastAvailable: "Yes",
      checkInTime: "16:00:00",
      checkOutTime: "11:00:00",
      rules: "Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "1320.00",
      singleOccupation: "NA",
      doubleOccupation: "NA",
      extraBedWithPerson: "NA",
      adultBreakfast: "NA",
      adultLunch: "NA",
      adultDinner: "NA",
      childBreakfast: "NA",
      childLunch: "NA",
      childDinner: "NA",
  
    },


    //Adventure
 //1th
    {
      Information:"Host Details",
      host: "Puja Kale",
      email: "reservations@agreenhotels.in",
      phone: "+91-9970765500",
      address: "Forest Escapes Koyna at post Goshatwadi, Taluka patan Goshatwadi(415206) Satara, Maharashtra, India",
      state:"Maharashtra",
      country:"	India",
      images: [Agreen_Resort1, Agreen_Resort2, Agreen_Resort3, Agreen_Resort4, Agreen_Resort5, Agreen_Resort6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Forest Villas-Agreen Villa",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "3",
      singleBeds: "4",
      doubleBeds: "3",
      livingRooms: "1",
      otherSpaces: "3",
      adultsAllowed: "6",
      childrenAllowed: "YES",
      childAgeLimit: "2",
      numberOfChildrenAllowed: "4",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Tea & Coffee Maker, Essentials, First Aid Kit, Fire Extinguisher",
      entertainmentFacilities: "Flat-screen TV,Minibar",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "11:00:00",
      rules: "	Smoking Allowed,Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "23000.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //2th
    {
      Information:"Host Details",
      host: "Prathamesh Samant",
      email: "prathamesh.pps@gmail.com",
      phone: "+91-9970765500",
      address: "Ishavasyam,Major State highway 4(Coastal highway),Manjardewadi, At Post-Parule,Tal-Vengurle, Dist-Sindhudurg(416523) Sindhudurg, Maharashtra, India",
      state:"Maharashtra",
      country:"	India",
     images: [Maachli_Farm1, Maachli_Farm2, Maachli_Farm3, Maachli_Farm4, Maachli_Farm5,Maachli_Farm6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Maachli, Home Stay",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "4",
      singleBeds: "4",
      doubleBeds: "4",
      livingRooms: "1",
      otherSpaces: "0",
      adultsAllowed: "8",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Tea & Coffee Maker, Essentials, First Aid Kit, Fire Extinguisher",
      entertainmentFacilities: "Flat-screen TV",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "13:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "9300.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },


    //3th
    {
      Information:"Host Details",
      host: "Nazeem khan",
      email: "reservations@agreenhotels.in",
      phone: "+91-9970765500",
      address: "National Park,Pench(480661)",
      state:"	Madhya Pradesh",
      country:"	India",
      images: [villagecamp1, villagecamp2, villagecamp3, villagecamp4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Village camp",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "9",
      singleBeds: "4",
      doubleBeds: "9",
      livingRooms: "1",
      otherSpaces: "1",
      adultsAllowed: "20",
      childrenAllowed: "YES",
      childAgeLimit: "	1",
      numberOfChildrenAllowed: "6",
      maxGuestsAllowed: "14",
      basicFacilities: "air conditioning,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "13:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed,Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "4100.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //4th
    {
      Information:"Host Details",
      host: "Neha Uikey",
      email: "info@oliveresorts.com",
      phone: "+91-9970765500",
      address: "Pench National Park,Sillari(480661) Nagpur, Maharashtra, India",
      state:"Nagpur",
      country:"	India",
      images: [olivesillari1, olivesillari2, olivesillari3, olivesillari4, olivesillari5],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Olive Resort-Sillari",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "8",
      singleBeds: "5",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "4",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "8",
      basicFacilities: "Air conditioning,Free wifi,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "14:00:00",
      checkOutTime: "12:00:00",
      rules: "Smoking Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: " 3800.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //5th
    {
      Information:"Host Details",
      host: "Neha Uikey",
      email: "info@oliveresorts.com",
      phone: "+91-9970765500",
      address: "Pench Natioanl Park,Turia(480661) Seoni, Madhya Pradesh, India",
      state:"	Madhya Pradesh",
      country:"	India",
      images: [Olive_Turia1, Olive_Turia2, Olive_Turia3, Olive_Turia4, Olive_Turia5, Olive_Turia6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Olive Resort-Turia",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "8",
      singleBeds: "6",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "20",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "6",
      maxGuestsAllowed: "8",
      basicFacilities: "Air conditioning,Free wifi,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "14:00:00",
      checkOutTime: "12:00:00",
      rules: "Smoking Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "3800.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //6th
    {
      Information:"Host Details",
      host: "Nitin Mahajan",
      email: "sanctuarytadobaresort@gmail.com",
      phone: "+91-9970765500",
      address: "Tadoba National Park,Tadoba(442906) Chandrapur, Maharashtra, India",
      state:"Maharashtra",
      country:"	India",
      images: [sanctuary1, sanctuary2, sanctuary3, sanctuary4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "The Sanctuary -Tadoba Resort",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "8",
      singleBeds: "8",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "6",
      maxGuestsAllowed: "10",
      basicFacilities: "Air conditioning,Free wifi,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen,Kitchenette,Laundry",
      breakfastAvailable: "Yes",
      checkInTime: "14:00:00",
      checkOutTime: "12:00:00",
      rules: "Smoking Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: " 4800.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //7th
    {
      Information:"Host Details",
      host: "Suman Manna",
      email: "banyantreecamp@gmail.com ",
      phone: "+91-9970765500",
      address: "Pench National Park,Pench(480661) Shivapuri, Madhya Pradesh, India",
      state:"	Madhya Pradesh",
      country:"	India",
      images: [Banayan_Tree1, Banayan_Tree2, Banayan_Tree3, Banayan_Tree4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "BANYAN TREE CAMP",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "6",
      singleBeds: "6",
      doubleBeds: "6",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "6",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "6",
      maxGuestsAllowed: "10",
      basicFacilities: "air conditioning,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "	Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "13:00:00",
      checkOutTime: "12:00:00",
      rules: "	Children Allowed,Parties/Events Allowed",
      totalPriceINR: " 5700.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //8th
    {
      Information:"Host Details",
      host: "Pankaj Kukde",
      email: "operationsjunglehome@gmail.com",
      phone: "+91-9970765500",
      address: "Pench National Park,Turia Gate(480661) Seoni, Madhya Pradesh, India",
      state:"Madhya Pradesh",
      country:"	India",
       images: [Welcome_Heritage1, Welcome_Heritage2, Welcome_Heritage3, Welcome_Heritage4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Welcome heritage Resort",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "10",
      singleBeds: "6",
      doubleBeds: "5",
      livingRooms: "2",
      otherSpaces: "4",
      adultsAllowed: "15",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "4",
      maxGuestsAllowed: "14",
      basicFacilities: "Air Conditioning,Heating,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "	Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen,Washing machine",
      breakfastAvailable: "Yes",
      checkInTime: "14:00:00",
      checkOutTime: "11:00:00",
      rules: "Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "6600.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //9th
    {
      Information:"Host Details",
      host: "Swati Peshkar",
      email: "tigervillage.tadoba@gmail.com",
      phone: "+91-9970765500",
      address: "Moharli Gate, Tadoba, Moharli(442404) Chandrapur, Maharashtra, India",
      state:"Maharashtra",
      country:"	India",
      images: [Tiger_Village1, Tiger_Village2, Tiger_Village3, Tiger_Village4, Tiger_Village5],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Tiger Village Resort",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "10",
      singleBeds: "4",
      doubleBeds: "5",
      livingRooms: "5",
      otherSpaces: "3",
      adultsAllowed: "5",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "6",
      maxGuestsAllowed: "18",
      basicFacilities: "Air Conditioning, Free on-site parking,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "	Flat-screen TV",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "13:00:00",
      checkOutTime: "11:30:00",
      rules: "Children Allowed,Parties/Events Allowed,",
      totalPriceINR: "6060.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //10th
    {
      Information:"Host Details",
      host: "Sahana Kamat",
      email: "dewdropsdandeli@gmail.com",
      phone: "+91-9970765500",
      address: "Kogilban, Dandeli(581325) DANDELI, Karnataka, India",
      state:"Karnataka",
      country:"	India",
      images: [Dewdrops_Jungle1, Dewdrops_Jungle2, Dewdrops_Jungle3, Dewdrops_Jungle4, Dewdrops_Jungle5, Dewdrops_Jungle6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "DEWDROPS JUNGLE RESORT",
      description: "Situated at the heart of Dandeli, this soulful resort will refresh your mind and take you away from the hustle and bustle of the city. Get on a journey to witness the beauty of nature amidst a plethora of birds, amphibians, reptiles, and flowering plants. Beautifully tucked under the mesmerizing canopy of the Western Ghats, Dandeli is a picturesque town in northern Karnataka.",
      bedrooms: "10",
      singleBeds: "5",
      doubleBeds: "10",
      livingRooms: "1",
      otherSpaces: "5",
      adultsAllowed: "15",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "10",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Free wifi,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "10:00:00",
      rules: "Smoking Allowed,Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "3800.00",
      singleOccupation: "1980",
      doubleOccupation: "3850",
      extraBedWithPerson: "550",
      adultBreakfast: "220",
      adultLunch: "385",
      adultDinner: "495",
      childBreakfast: "83",
      childLunch: "121",
      childDinner: "121",
  
    },

    //11th
    {
      Information:"Host Details",
      host: "Homayon Khoram",
      email: "mail@pranavamresort.com",
      phone: "+91-9970765500",
      address: "Pranavam Resort Pozhuthana Vythiri Wayanad(673575) Wayanad, Kerala, India",
      state:"Kerala",
      country:"	India",
      images: [Pranavam_Resort1, Pranavam_Resort2, Pranavam_Resort3, Pranavam_Resort4, Pranavam_Resort5],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Pranavam Resort",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "8",
      singleBeds: "8",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "3",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning,,Free wifi,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "	Flat-screen TV,Swimming Pool,",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "13:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed,Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "7700.00",
      singleOccupation: "6050",
      doubleOccupation: "8250",
      extraBedWithPerson: "330",
      adultBreakfast: "83",
      adultLunch: "495",
      adultDinner: "495",
      childBreakfast: "50",
      childLunch: "121",
      childDinner: "121",
  
    },

    //12th
    {
      Information:"Host Details",
      host: "sovhita shalgar",
      email: "shalgarvilla@gmail.com",
      phone: "+91-9970765500",
      address: "	4 kms close to kaas valley of flowers kaas plateau Satara Maharashtra(415013)",
      state:"Maharashtra",
      country:"	India",
      images: [shalgahr_Villa1, shalgahr_Villa2, shalgahr_Villa3, shalgahr_Villa4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Shalgar Villa the homestay",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "10",
      singleBeds: "10",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "3",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Free wifi,Free on-site parking,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "11:00:00",
      rules: "Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "2100.00",
      singleOccupation: "2090",
      doubleOccupation: "2090",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //13th
    {
      Information:"Host Details",
      host: "Nikhil Dushing",
      email: "nikhil.dushing31@gmail.com",
      phone: "+91-9970765500",
      address: "Near madhe ghat waterfall, village Shenwad, Velhe Pune taluka Maharashtra(412212)",
      state:"Maharashtra",
      country:"	India",
     images: [Bottom_Palm1, Bottom_Palm2, Bottom_Palm3, Bottom_Palm4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Bottom Palm Resort",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "10",
      singleBeds: "5",
      doubleBeds: "10",
      livingRooms: "1",
      otherSpaces: "4",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Free wifi,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "10:00:00",
      rules: "Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "2750.00",
      singleOccupation: "	2750",
      doubleOccupation: "	2750",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //14th
    {
      Information:"Host Details",
      host: "Aziz Bhori",
      email: "whisperingwoodsamba@gmail.com",
      phone: "+91-9970765500",
      address: "Amba Ghat Kolhapur(415101) Kolhapur, Maharashtra, India",
      state:"Maharashtra",
      country:"	India",
     images: [Whispering1, Whispering2, Whispering3],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Whispering Jungle Homestay",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "6",
      singleBeds: "6",
      doubleBeds: "6",
      livingRooms: "1",
      otherSpaces: "4",
      adultsAllowed: "8",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "4",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Free wifi,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "10:00:00",
      rules: "	Smoking Allowed,Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "2200.00",
      singleOccupation: "2200",
      doubleOccupation: "2200",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //15th
    {
      Information:"Host Details",
      host: "Anjali Joshi",
      email: "anjalivinayakjoshi@yahoo.co.in",
      phone: "+91-9970765500",
      address: "Gondwana Premium Jungle Resort Madanapur Chimur Maharashtra(442903) Chandrapur, Maharashtra, India",
      state:"Maharashtra",
      country:"	India",
     images: [Gondwana1, Gondwana2, Gondwana3, Gondwana4, Gondwana5, Gondwana6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Gondwana Premium Jungle Home Saty",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "5",
      singleBeds: "5",
      doubleBeds: "5",
      livingRooms: "1",
      otherSpaces: "5",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "8",
      basicFacilities: "Air Conditioning, Free wifi,Heating,Iron,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "11:00:00",
      rules: "Children Allowed,Parties/Events Allowed",
      totalPriceINR: " 6600.00",
      singleOccupation: "6600",
      doubleOccupation: "6600",
      extraBedWithPerson: "1000",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },
    

  //16th
    {
      Information:"Host Details",
      host: "swa",
      email: "sw@gmail.com",
      phone: "9881711134",
      address: "hiii(411043) Karjat, Maharashtra, India",
      state:"Maharashtra",
      country:"	India",
      images: [villagecamp1, villagecamp2, villagecamp3, villagecamp4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "SS",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "NA",
      tents:"2",
      singleBeds: "NA",
      doubleBeds: "NA",
      livingRooms: "NA",
      otherSpaces: "NA",
      adultsAllowed: "NA",
      childrenAllowed: "NA",
      childAgeLimit: "NA",
      numberOfChildrenAllowed: "NA",
      maxGuestsAllowed: "NA",
      basicFacilities: "Camp Fire Facility",
      entertainmentFacilities: "NA",
      tentTypes:"Non AC Tents",
      cookingCleaningFacilities: "NA",
      breakfastAvailable: "NA",
      checkInTime: "16:40:00",
      checkOutTime: "22:40:00",
      rules: "Smoking Allowed",
      totalPriceINR: " NA",
      singleOccupation: "NA",
      doubleOccupation: "NA",
      extraBedWithPerson: "NA",
      adultBreakfast: "NA",
      adultLunch: "NA",
      adultDinner: "NA",
      childBreakfast: "NA",
      childLunch: "NA",
      childDinner: "NA",
  
    },


    //Beaches Data

 //1th
    {
      Information:"Host Details",
      host: "Avinash Khot",
      email: "athakurhr@rediffmail.com",
      phone: "+91-9970765500",
      address: "Khavane Beach,Konkan(416207) Konkan, Maharashtra, India",
      state:"Maharashtra",
      country:"	India",
      images: [Blue_Lagoon1, Blue_Lagoon2, Blue_Lagoon3, Blue_Lagoon4, Blue_Lagoon5, Blue_Lagoon6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Blue Lagoon Khavane Resort",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "8",
      singleBeds: "4",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "4",
      adultsAllowed: "20",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "10",
      maxGuestsAllowed: "1",
      basicFacilities: "Air Conditioning,Free wifi,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool,Minibar",
      cookingCleaningFacilities: "Kitchen,Washing machine",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed,Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "4100.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //2th
    {
      Information:"Host Details",
      host: "Manish katti",
      email: "kastooritravels.kop@gmail.com",
      phone: "+91-9970765500",
      address: "Tondavali(Madhali),karanjewadi StopMalvan(416606) Sindhudurg, Maharashtra, India",
      state:"Maharashtra",
      country:"	India",
     images: [Nityanand1, Nityanand2, Nityanand3, Nityanand4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Nityanand Pride Beach Resort",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "10",
      singleBeds: "5",
      doubleBeds: "10",
      livingRooms: "1",
      otherSpaces: "4",
      adultsAllowed: "6",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "6",
      maxGuestsAllowed: "8",
      basicFacilities: "Air Conditioning,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "10:00:00",
      checkOutTime: "12:00:00",
      rules: "Smoking Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "3200.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },


    //3th
    {
      Information:"Host Details",
      host: "Ameya Bal",
      email: "ameyasbal@gmail.com",
      phone: "+91-9970765500",
      address: "Ameya Nursery,Village Ladghar,Tal:Dapoli,Dist: Ratnagiri(415712) Ratnagiri, Maharashtra, India",
      state:"	Madhya Pradesh",
      country:"	India",
      images: [The_Waterfront1, The_Waterfront2, The_Waterfront3, The_Waterfront4, The_Waterfront5, The_Waterfront6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Bangli Home-Stay",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "8",
      singleBeds: "4",
      doubleBeds: "4",
      livingRooms: "3",
      otherSpaces: "4",
      adultsAllowed: "8",
      childrenAllowed: "YES",
      childAgeLimit: "	1",
      numberOfChildrenAllowed: "6",
      maxGuestsAllowed: "10",
      basicFacilities: "Air conditioning,Heating,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher,",
      entertainmentFacilities: "Flat-screen TV",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "14:00:00",
      checkOutTime: "11:00:00",
      rules: "Pets Allowed,Children Allowed,Parties/Events Allowed,",
      totalPriceINR: "4100.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //4th
    {
      Information:"Host Details",
      host: "Makarand Chitale",
      email: "megh_mak@yahoo.com",
      phone: "+91-9970765500",
      address: "Suvarna Ganesh Pakhadi, Shrivardhan Rd, Diveagar(402404) Konkan, Maharashtra, India",
      state:"Nagpur",
      country:"	India",
     images: [Kshitij_Holiday1, Kshitij_Holiday2, Kshitij_Holiday3],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Kshitij Holiday Resort",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "6",
      singleBeds: "3",
      doubleBeds: "3",
      livingRooms: "2",
      otherSpaces: "2",
      adultsAllowed: "1",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "6",
      maxGuestsAllowed: "16",
      basicFacilities: "Air conditioning,Free wifi,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "10:00:00",
      rules: "Smoking Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: " 3900.00",
      singleOccupation: "0",
      doubleOccupation: "0",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //5th
    {
      Information:"Host Details",
      host: "Yogesh Bhagwat",
      email: "yogeshbhagwat76@gmail.com",
      phone: "+91-9970765500",
      address: "Pranjape Lane Kelshi, Tal- Dapoli Dist- RatnagiriI(415717)",
      state:"	Maharashtra",
      country:"	India",
      images: [Tranquil1, Tranquil2, Tranquil3, Tranquil4, Tranquil5, Tranquil6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Tranquil Home Stay",
      description: "Despite being situated in the heart of the bungalow, this is one of those homestays in Kelshi that is surrounded by natural beauty",
      bedrooms: "4",
      singleBeds: "4",
      doubleBeds: "4",
      livingRooms: "1",
      otherSpaces: "4",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "air conditioning,Free wifi,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "10:00:00",
      checkOutTime: "10:00:00",
      rules: "Smoking Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "2300.00",
      singleOccupation: "1650",
      doubleOccupation: "2200",
      extraBedWithPerson: "220",
      adultBreakfast: "165",
      adultLunch: "495",
      adultDinner: "605",
      childBreakfast: "88",
      childLunch: "121",
      childDinner: "132",
  
    },

    //6th
    {
      Information:"Host Details",
      host: "Anuprita Patil",
      email: "patilanuprita91@gmail.com",
      phone: "+91-9970765500",
      address: "At PostKihim,Bhandar Ali,kalbhairav Lane,Alibagh(402201) Raigad, Maharashtra, India",
      state:"Maharashtra",
      country:"	India",
      images: [Arunday1, Arunday2, Arunday3, Arunday4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "ARUNODAY KIHIM",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "6",
      singleBeds: "3",
      doubleBeds: "6",
      livingRooms: "1",
      otherSpaces: "3",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "8",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning,Free wifi,Heating,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV",
      cookingCleaningFacilities: "NA",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: " 2100.00",
      singleOccupation: "1870",
      doubleOccupation: "1870",
      extraBedWithPerson: "220",
      adultBreakfast: "121",
      adultLunch: "385",
      adultDinner: "495",
      childBreakfast: "83",
      childLunch: "121",
      childDinner: "132",
  
    },

    //7th
    {
      Information:"Host Details",
      host: "Swapnil Mathre",
      email: "swapnilmathre010@gmail.com",
      phone: "+91-9970765500",
      address: "Sasawane Beach Road Home Sasawane(402201) Raigad, Maharashtra, India",
      state:"	Madhya Pradesh",
      country:"	India",
     images: [Sagari1, Sagari2, Sagari3],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Sagari Kinara",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "10",
      singleBeds: "5",
      doubleBeds: "5",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "8",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning,Free on-site parking,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "	Flat-screen TV",
      cookingCleaningFacilities: "NA",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed,Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: " 2300.00",
      singleOccupation: "2200",
      doubleOccupation: "2200",
      extraBedWithPerson: "220",
      adultBreakfast: "55",
      adultLunch: "440",
      adultDinner: "440",
      childBreakfast: "28",
      childLunch: "121",
      childDinner: "121",
  
    },

    //8th
    {
      Information:"Host Details",
      host: "Chaitanya Apte",
      email: "apte.chaitanya87@gmail.com",
      phone: "+91-9970765500",
      address: "Near Gram Panchayat, Kolivada, Karmarkar meseum.(402201) Raigad, Maharashtra, India",
      state:"Maharashtra",
      country:"	India",
      images: [chaitanya1, chaitanya2, chaitanya3],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Sagar Darshan Holiday Home",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "6",
      singleBeds: "4",
      doubleBeds: "6",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "4",
      numberOfChildrenAllowed: "1",
      maxGuestsAllowed: "6",
      basicFacilities: "air conditioning,Free on-site parking,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "	NA",
      cookingCleaningFacilities: "NA",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "12:00:00",
      rules: "Smoking Allowed,Pets Allowed,Children Allowed",
      totalPriceINR: "2300.00",
      singleOccupation: "2376",
      doubleOccupation: "2376",
      extraBedWithPerson: "108",
      adultBreakfast: "49",
      adultLunch: "486",
      adultDinner: "486",
      childBreakfast: "27",
      childLunch: "243",
      childDinner: "243",
  
    },

    //9th
    {
      Information:"Host Details",
      host: "Bhumit Gala",
      email: "hrishivanvillas@gmail.com",
      phone: "+91-9970765500",
      address: "3006, valanj paroda, nagaon, alibag(402201) Raigad, Maharashtra, India",
      state:"Maharashtra",
      country:"	India",
       images: [Hrishivan1, Hrishivan2, Hrishivan3, Hrishivan4, Hrishivan5, Hrishivan6],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Hrishivan Villas Nagaon",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "8",
      singleBeds: "4",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "4",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "6",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning,Free wifi,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "	Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "11:30:00",
      rules: "Smoking Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "3000.00",
      singleOccupation: "1890",
      doubleOccupation: "2625",
      extraBedWithPerson: "210",
      adultBreakfast: "79",
      adultLunch: "473",
      adultDinner: "473",
      childBreakfast: "47",
      childLunch: "116",
      childDinner: "116",
  
    },

    //10th
    {
      Information:"Host Details",
      host: "Niwas Sakhalkar",
      email: "saieshresort@gmail.com",
      phone: "+91-9970765500",
      address: "Sasawane, Near Pednekar Maharaj Aashram., Alibag(402201) Raigad, Maharashtra, India",
      state:"Karnataka",
      country:"	India",
      images: [roadTrip, HillStation, Adventure, roadTrip, HillStation, Adventure],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Saiesh Resort",
      description: "Situated at the heart of Dandeli, this soulful resort will refresh your mind and take you away from the hustle and bustle of the city. Get on a journey to witness the beauty of nature amidst a plethora of birds, amphibians, reptiles, and flowering plants. Beautifully tucked under the mesmerizing canopy of the Western Ghats, Dandeli is a picturesque town in northern Karnataka.",
      bedrooms: "8",
      singleBeds: "4",
      doubleBeds: "8",
      livingRooms: "1",
      otherSpaces: "3",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "8",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning,Free wifi,Free on-site parking,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "NA",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed,Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "2000.00",
      singleOccupation: "1980",
      doubleOccupation: "2200",
      extraBedWithPerson: "220",
      adultBreakfast: "83",
      adultLunch: "495",
      adultDinner: "495",
      childBreakfast: "50",
      childLunch: "121",
      childDinner: "121",
  
    },

    //11th
    {
      Information:"Host Details",
      host: "Kaustubh Bhingarde",
      email: "kaustubhingarde@gmail.com",
      phone: "+91-9970765500",
      address: "Bhingarde Hotel Kirti At & Post - Dhokwade No.1, Tal. - Alibag, Dist. - Raigad(402201)",
      state:"Kerala",
      country:"	India",
      images: [Kirti1, Kirti2, Kirti3, Kirti4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Kirti cottage",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "6",
      singleBeds: "3",
      doubleBeds: "6",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "8",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "6",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning,,Free wifi,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "	Flat-screen TV",
      cookingCleaningFacilities: "NA",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "10:00:00",
      rules: "Children Allowed,Parties/Events Allowed",
      totalPriceINR: "2000.00",
      singleOccupation: "2090",
      doubleOccupation: "2090",
      extraBedWithPerson: "220",
      adultBreakfast: "83",
      adultLunch: "495",
      adultDinner: "495",
      childBreakfast: "50",
      childLunch: "121",
      childDinner: "121",
  
    },

    //12th
    {
      Information:"Host Details",
      host: "Samir Sataradekar",
      email: "khavanaholidays@gmail.com",
      phone: "+91-9970765500",
      address: "Khavane beach Maruti Mandir Rd Mhapan Vengurla Maharashtra(416522)",
      state:"Maharashtra",
      country:"	India",
     images: [Klub_khavana1, Klub_khavana2, Klub_khavana3, Klub_khavana4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Klub Khavana Beachfront Resort",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "10",
      singleBeds: "5",
      doubleBeds: "10",
      livingRooms: "1",
      otherSpaces: "3",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Free wifi,Free on-site parking,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "11:00:00",
      rules: "Smoking Allowed,Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "2300.00",
      singleOccupation: "2750",
      doubleOccupation: "2090",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "350",
      adultDinner: "450",
      childBreakfast: "0",
      childLunch: "120",
      childDinner: "120",
  
    },

    //13th
    {
      Information:"Host Details",
      host: "Amey Pusalkar",
      email: "aquablissbeachresort@outlook.com",
      phone: "+91-9970765500",
      address: "103 Varchi pakhadi Dapoli Murud near durgadevi mandir.(415713) Ratnagiri, Maharashtra, India",
      state:"Maharashtra",
      country:"	India",
      images: [Aqua_bliss1 , Aqua_bliss2, Aqua_bliss3],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Aqua Bliss - A Comfort Family Stay",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "10",
      singleBeds: "10",
      doubleBeds: "10",
      livingRooms: "1",
      otherSpaces: "4",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning, Free wifi,Free on-site parking,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "12:30:00",
      checkOutTime: "10:30:00",
      rules: "Smoking Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "3800.00",
      singleOccupation: "	3850",
      doubleOccupation: "	3850",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

    //14th
    {
      Information:"Host Details",
      host: "Alhad Bhide",
      email: "alhad26@gmail.com",
      phone: "+91-9970765500",
      address: "ChaulNear Alibag(402203) Raigad, Maharashtra, India",
      state:"Maharashtra",
      country:"	India",
     images: [Casa_Da_Chaul1, Casa_Da_Chaul2, Casa_Da_Chaul3, Casa_Da_Chaul4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Casa Da Chaul",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "10",
      singleBeds: "10",
      doubleBeds: "10",
      livingRooms: "1",
      otherSpaces: "6",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "5",
      maxGuestsAllowed: "10",
      basicFacilities: "Air Conditioning,Free wifi,Free on-site parking,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher,",
      entertainmentFacilities: "Flat-screen TV,Swimming Pool",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "12:00:00",
      checkOutTime: "10:00:00",
      rules: "Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: "23000.00",
      singleOccupation: "22000",
      doubleOccupation: "22000",
      extraBedWithPerson: "2000",
      adultBreakfast: "0",
      adultLunch: "450",
      adultDinner: "450",
      childBreakfast: "0",
      childLunch: "350",
      childDinner: "350",
  
    },

    //15th
    {
      Information:"Host Details",
      host: "Ishan laukik",
      email: "prajwalkadam03@gmail.com",
      phone: "+91-9970765500",
      address: "Dapoli - Harnai road, near Palande beach, Harnai, MH SH4, Dapoli, Maharashtra 415713(415713)",
      state:"Maharashtra",
      country:"	India",
    images: [villagecamp1, villagecamp2, villagecamp3, villagecamp4],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Ishan laukik niwas",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "3",
      singleBeds: "1",
      doubleBeds: "1",
      livingRooms: "1",
      otherSpaces: "1",
      adultsAllowed: "10",
      childrenAllowed: "YES",
      childAgeLimit: "5",
      numberOfChildrenAllowed: "3",
      maxGuestsAllowed: "25",
      basicFacilities: "Air Conditioning, Free wifi,Heating,Iron,Tea & Coffe Maker,Desk/workspace,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Minibar,Sauna",
      cookingCleaningFacilities: "Kitchenette",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "23:00:00",
      rules: "Smoking Allowed,Pets Allowed,Children Allowed,Parties/Events Allowed",
      totalPriceINR: " 4200.00",
      singleOccupation: "1575",
      doubleOccupation: "3150",
      extraBedWithPerson: "100",
      adultBreakfast: "0",
      adultLunch: "500",
      adultDinner: "500",
      childBreakfast: "0",
      childLunch: "200",
      childDinner: "200",
  
    },
    

  //16th
    {
      Information:"Host Details",
      host: "swapnaja sawant",
      email: "swapnajasawant020@gmail.com",
      phone: "+91-9970765500",
      address: "	House no. 93 madhala watar sadamirya ratnagiri(412516)",
      state:"Maharashtra",
      country:"	India",
      images: [roadTrip, HillStation, Adventure, roadTrip, HillStation, Adventure],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Chaitanya Home Stay",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "4",
      tents:"2",
      singleBeds: "4",
      doubleBeds: "4",
      livingRooms: "1",
      otherSpaces: "1",
      adultsAllowed: "4",
      childrenAllowed: "Yes",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "3",
      maxGuestsAllowed: "4",
      basicFacilities: "	Free wifi,Heating,Free on-site parking,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV",
      tentTypes:"Non AC Tents",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "11:00:00",
      checkOutTime: "10:00:00",
      rules: "Children Allowed",
      totalPriceINR: " 1320",
      singleOccupation: "1320",
      doubleOccupation: "1320",
      extraBedWithPerson: "200",
      adultBreakfast: "0",
      adultLunch: "450",
      adultDinner: "450",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },

//17th
    {
      Information:"Host Details",
      host: "Mandar Kadam",
      email: "ratnaviharresidency@gmail.com",
      phone: "+91-9970765500",
      address: "	House No 516 At Post Basani Taluka Ratnagiri(415612)",
      state:"Maharashtra",
      country:"	India",
       images: [Pranavam_Resort1, Pranavam_Resort2, Pranavam_Resort3, Pranavam_Resort4, Pranavam_Resort5],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Ratnavihar Residency",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "4",
      tents:"2",
      singleBeds: "4",
      doubleBeds: "4",
      livingRooms: "1",
      otherSpaces: "1",
      adultsAllowed: "8",
      childrenAllowed: "Yes",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "4",
      maxGuestsAllowed: "4",
      basicFacilities: "Free wifi,Heating,Free on-site parking,Iron,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher,",
      entertainmentFacilities: "Flat-screen TV",
      tentTypes:"Non AC Tents",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "23:54:00",
      checkOutTime: "22:54:00",
      rules: "Pets Allowed,Children Allowed",
      totalPriceINR: " 1100",
      singleOccupation: "1210",
      doubleOccupation: "1210",
      extraBedWithPerson: "0",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },


    //18th
    {
      Information:"Host Details",
      host: "Sunit Suresh Shildankar",
      email: "sunitshildankar01@gmail.com",
      phone: "+91-9970765500",
      address: "Govt. Hospital, Near, Dhokawade, At- Sasawane, (Ramnagar), Tal- Alibag - Dist - Raigad .Mandwa Road, Alibag, Maharashtra(402201)",
      state:"Maharashtra",
      country:"	India",
            images: [Swami_Chaya1, Swami_Chaya2, Swami_Chaya3],
      mainDescription: "Driving across the beautiful roads of India will give you an experience of a lifetime. You can take most of the country by car and witness the natural beauty; whether its drive across North to South or East to West that lets you admire the beauty of golden beaches and national park or Himalaya Road that passes by majestic glaciers, lakes and mountains.For every one of us, travel came first. We’ve spent years living as nomads, pioneers, and voyagers— from forest in India to trekking in the Mountains—travel is what we do.The great India road trip has a vaunted place in this country's history, and rightfully So RVAAS is the best way to explore them and come back with a bag full of beautiful memories and your souls refreshed after a tour in the lap of nature’s beauty",
      name: "Ri Cottage",
      description: "Escape to the heart of evergreen Mangaal Farmstay for short break every year. A gorgeous resort with an eco-friendly purpose, Mangaal Farmstay makes for a unique travel experience for those who want to escape the hectic city life.",
      bedrooms: "4",
      tents:"2",
      singleBeds: "4",
      doubleBeds: "4",
      livingRooms: "1",
      otherSpaces: "2",
      adultsAllowed: "8",
      childrenAllowed: "Yes",
      childAgeLimit: "1",
      numberOfChildrenAllowed: "4",
      maxGuestsAllowed: "8",
      basicFacilities: "Heating,Free on-site parking,Tea & Coffe Maker,Essentials,First aid kit,Fire extinguisher",
      entertainmentFacilities: "Flat-screen TV",
      tentTypes:"Non AC Tents",
      cookingCleaningFacilities: "Kitchen",
      breakfastAvailable: "Yes",
      checkInTime: "10:11:00",
      checkOutTime: "10:11:00",
      rules: "Children Allowed,Parties/Events Allowed",
      totalPriceINR: " 1540.00",
      singleOccupation: "1540",
      doubleOccupation: "1540",
      extraBedWithPerson: "250",
      adultBreakfast: "0",
      adultLunch: "0",
      adultDinner: "0",
      childBreakfast: "0",
      childLunch: "0",
      childDinner: "0",
  
    },



  
    
  ];



//  Blog Section Data
export const blogs = [
  {
    slug: "adventure-blog",
    title: "Adventure Blog",
    content: `
"आस्ते भग आसीनस्य, ऊध्वर्स्तिष्ठति तिष्ठतः।
शेते निपद्यमानस्य, चराति चरतो भगः।
(The fate of a person who sits, also seats. The fate of a standing person also stands and the fate of a sleeping person also sleeps. But the fate of a person who walks (travels) also walks (grows) along.)

चरन् वै मधु विन्दति, चरन् स्वादुमुदुम्बरम्।
सूयर्स्य पश्य श्रेमाणं, यो न तन्द्रयते चरन्।
(The one who travels enjoys the nectar. The same enjoy sweet fruits. Look at the efforts of lord Surya, he is never tired of walking.)

White Water Rafting,Goa
While white water rafting in Rishikesh is popular worldwide, we urge you to try this famous adventure activity in Goa as well. Given the popularity of other water rides in Goa, people often tend to undermine this exhilarating sport. You can book an entire expedition with your loved ones at the best prices in Goa or join one as an individual. The stretch of white water rafting is usually 10 km long, and it is replete with areas where the flow is fast and current strong. The agency you book your expedition with will provide you with the necessary directions and also the equipment like life jackets and oars.

So, if you are planning a trip to Goa with your friends and family, this one is not to be missed.
Adrenaline Pumping Level : Moderate
Places popular for it : Tilari River, Mandovi River, Goa
Best Season : June to September"`,
    image: Img1,
  },
  {
    slug: "travel-blog",
    title: "Travel Blog",
    content: `
"यस्तु संचरते देशान् यस्तु सेवेत पण्डितान् ।
तस्य विस्तारिता बुद्धिस्तैलबिन्दुरिवाम्भसि ॥
(The intelligence of a person who travels to different countries and associates with scholars expands, just as a drop of oil expands in water.)

Matheran
Matheran is a quaint hill station situated at around 800 metres above sea level. This eco-sensitive region has many viewpoints that offer 360-degree views of the stunning Sahyadri Range. The fascinating landscape offers a relaxing atmosphere to visitors. Meanwhile, thrill seekers can try their hand in some waterfall rappelling, trekking and rock climbing.

Distance from Mumbai : 83 km
Estimated Driving Time : 2 hours
Best Time to Visit : October to May
Tourist Attractions : Alexander Point, Louisa Point, Charlotte Lake, Echo Point, Sunset Point"`,
    image:Img2,
  },
  {
    slug: "historical-blog",
    title: "Historical Blog",
    content: `हृदि श्रीर्मस्तके राज्य पादे पर्यटनं फलम्।
(Sarva-siddhant-samgrah)

They have wealth in their hearts, kingship on their heads (responsibilities) and traveling on their feet.


**The Ajanta Caves**
The Ajanta Caves are a refined example of the rock-cut Buddhist prayer halls and monasteries built over a period of about 800 years starting from 2nd century BCE. While the early caves are an example of the simple reproduction of the earlier wooden structures, they evolved to having large halls with ornate pillars, columns and carved verandahs. However the most striking feature of the later temples are the elaborate murals on the walls and ceilings representing events from the life of Buddha, Bodhisattvas and scenes from Jataka Tales.

Despite working with almost no natural light inside the dark caves, these ancient artists managed to create masterpieces of Indian art. The recent restoration efforts of the Archaeological Survey of India (ASI) have carefully removed the past damages done to these paintings and have helped reveal the splendour of these murals to the world.


**The Ellora Caves**
Built during a later period, the Ellora Caves have Buddhist, Jain and Hindu rock-cut temples. The most prominent among these is the Kailasha Temple built in the 8th century CE. Not satisfied with just excavating a hole in a cave, the Kings instructed the entire rock face to be cut away. The temple has been carved from the hillside complete with enormous pillars, statues, gateways, corridors and walls depicting scenes from Hindu Mythology. In terms of the scale, the ground plan of the Kailasha Temple is believed to be the same as that of the Parthenon and the height about half of it. Historians have called it “the most stupendous single work of art executed in India”.`,
    image: Img3,
  }
];
